/* tslint:disable */

// ====================================================
// START: Typescript template
// ====================================================

// ====================================================
// Scalars
// ====================================================

/** A type representing a formatted java.util.UUID */
export type Uuid = any;

/** A type representing a Locale such as en_US or fr_FR */
export type Locale = any;

/** A type representing a full protocol, host and path */
export type Url = any;

/** Built-in java.math.BigDecimal */
export type BigDecimal = any;

// ====================================================
// InputTypes
// ====================================================

/** The input BEX context used for identifying users, sites and other platform functions */
export interface ContextInput {
  /** Information regarding the application which triggered the query */
  clientInfo?: ClientInfoInput | null;
  /** Currency as Alphabetic ISO 4217 code e.g. 'USD'. Use if default currency for Locale needs to be overwritten. */
  currency?: string | null;
  /** Debugging context, such as Abacus overrides */
  debugContext?: DebugContextInput | null;
  /** Client/user Device information */
  device: DeviceInput;
  /** The Expedia Affiliate Partner ID */
  eapid?: number | null;
  /** DEPRECATED: Optional Client/user information. Used for input only. Please send the DUIAD header instead.We no longer rely on identity for user determination.User determination is now based upon passed headers. Soon this will be made nullable and later removed.Will be replaced by JWTs when available. */
  identity?: IdentityInput | null;
  /** The context locale, e.g. en_US */
  locale: Locale;
  /** User preference for tracking which is only required in POSs that require tracking opt in */
  privacyTrackingState?: PrivacyTrackingState | null;
  /** The context Site ID, e.g. (70201 for Orbitz) */
  siteId: number;
}
/** Describe which application is invoking bex api */
export interface ClientInfoInput {
  /** Name of the application */
  name: string;
  /** Version of the application eg:18.10 or 5fbc9958 */
  version?: string | null;
}
/** Context used for debugging purposes, such as overriding Abacus experiments */
export interface DebugContextInput {
  /** Abacus exposure overrides to be applied */
  abacusOverrides: ExposureInput[];
  /** ALTER mode */
  alterMode?: AlterMode | null;
}
/** An exposure to an abacus experiment */
export interface ExposureInput {
  /** The experiment bucket of the exposure */
  bucket: number;
  /** The numeric Abacus ID for an experiment */
  id: string;
}
/** Device information */
export interface DeviceInput {
  type: DeviceType;
}
/** Identity information for a specific user or device */
export interface IdentityInput {
  /** The Expedia user authenticated state */
  authState?: AuthenticationState | null;
  /** The device ID (DUAID) */
  duaid: Uuid;
  /** The Expedia User ID */
  expUserId?: string | null;
  /** The user TUID */
  tuid?: string | null;
}
/** "The `TripItemInput` contains a tripViewId and tripItemId known by the TripDomain, plus an optional filter known to the Trips Graph.The set of supported filters is the same as defined in `TripsFilterInput` andprovides context to the Trip Item Details view for functions such as back navigation. */
export interface TripItemInput {
  filter?: string | null;

  tripItemId: string;

  tripViewId: string;
}
/** Dimensions for a presention object i.e. image or icon */
export interface DimensionsInput {
  density: number;

  height: number;

  width: number;
}
/** The `TripOverviewInput` complex type contains a `tripViewId` known by the TripDomain and an optional `filter` known by the Trips Graph Service.The tripViewId identifier is opaque to the client, it may be an EG Trip Identifier or an identifier used for Trip Sharing.The server will determine how much of the trip and which actions to return basedon the sharing rules associated with the TripViewId.The set of supported filters is the same as defined in `TripsFilterInput` andprovides context to the Trip Overview view for functions such as back navigation. */
export interface TripOverviewInput {
  filter?: string | null;

  tripViewId: string;
}
/** The `TripsFilterInput` contains a filter identifier.The set of supported filter identifiers is defined by the Trips Graph Serviceand may represent a simple filter like Upcoming or Past or an arbitrarilycomplex filter defined by an ML algorithm.See the Trips Graph team for a list of reserved values. */
export interface TripsFilterInput {
  filter: string;
}

export interface CarDetailContextInput {
  carOfferToken: string;
  /** Encoded string having certain offer information shown on search page. Eg. priceShown, avg category price */
  continuationContextualId?: string | null;

  rewardPointsSelection?: RewardsPointSelectionEnum | null;

  selectedAccessories?: string[] | null;
}
/** The core criteria needed for a car search */
export interface PrimaryCarCriteriaInput {
  dropOffDateTime: DateTimeInput;

  dropOffLocation?: CarRentalLocationInput | null;

  pickUpDateTime: DateTimeInput;

  pickUpLocation: CarRentalLocationInput;
}
/** A common date time, if you need to include timezone information, please use ZonedDateTime */
export interface DateTimeInput {
  /** The day of the month of the date */
  day: number;
  /** The hour of the datetime */
  hour: number;
  /** The minute of the hour */
  minute: number;
  /** The numeric month of the date */
  month: number;
  /** The second of the minute */
  second: number;
  /** The four-digit year of the date */
  year: number;
}
/** Provides the car rental location information */
export interface CarRentalLocationInput {
  airportCode?: string | null;

  coordinates?: CoordinatesInput | null;

  regionId?: string | null;

  searchTerm?: string | null;
}

export interface CoordinatesInput {
  /** The latitude of the point in degrees */
  latitude: number;
  /** The longitude of the point in degrees */
  longitude: number;
}
/** Key/Value elements that describes the search criteria often displayed to the customer as filters */
export interface ShoppingSearchCriteriaInput {
  booleans?: BooleanValueInput[] | null;

  counts?: NumberValueInput[] | null;

  dates?: DateValueInput[] | null;

  ranges?: RangeValueInput[] | null;

  selections?: SelectedValueInput[] | null;
}
/** Type used during a product search to specify a given boolean value like the factcustomer would prefer to search for direct flights only. */
export interface BooleanValueInput {
  id: string;

  value: boolean;
}
/** Type used during a product search to specify a given numeric value like the number of stars for a hotel. */
export interface NumberValueInput {
  id: string;

  value: number;
}
/** Type used during a product search to specify a given date. Usually this datewould not be a core search criteria like a departure day for a flight. */
export interface DateValueInput {
  id: string;

  value: DateInput;
}
/** A common date object */
export interface DateInput {
  /** The day of the month, e.g. `1` for the 1st */
  day: number;
  /** The numeric month, e.g. `1` for January */
  month: number;
  /** The four-digit year e.g. `1999` */
  year: number;
}
/** Type used during a product search to specify a given numeric range like theprice of a hotel should be between 100 and 200 (USD). */
export interface RangeValueInput {
  id: string;

  max: number;

  min: number;
}
/** Type used during a product search to specify a given selection like the airline the customer would like to fly with. */
export interface SelectedValueInput {
  id: string;

  value: string;
}
/** The shopping context used for all search paths, contains the search contexts for the different shopping paths */
export interface ShoppingContextInput {
  multiItem?: MultiItemContextInput | null;
}
/** The multi-item context used for package searches, contains information neededfor package searches and retrieving package sessions */
export interface MultiItemContextInput {
  /** The multi-item session id used to retrieve the customers package search criteria and selected products */
  id: string;
  /** The package type for this search */
  packageType: PackageType;
}

export interface GroundTransfersSearchCriteriaInput {
  primary: PrimaryGroundTransfersCriteriaInput;

  secondary?: ShoppingSearchCriteriaInput | null;
}
/** The core criteria needed for a ground transfers or air transportation search */
export interface PrimaryGroundTransfersCriteriaInput {
  dateRange: OptionalDateTimeRangeInput;

  direction: GroundTransfersDirection;

  locations: GroundTransfersLocationInput[];

  travelerDetails: GroundTransfersTravelerDetailsInput[];
}
/** A range of dates & times, without timezone support, from a starting date & time to an ending date & time */
export interface OptionalDateTimeRangeInput {
  /** Optional terminal date & time in this range */
  end?: DateTimeInput | null;
  /** Optional starting date & time in this range */
  start?: DateTimeInput | null;
}
/** Provides the ground transfers location information for destination, airport and hotel */
export interface GroundTransfersLocationInput {
  coordinates?: CoordinatesInput | null;

  id?: string | null;

  name?: string | null;

  type: GeoType;
}
/** Represents the traveler details */
export interface GroundTransfersTravelerDetailsInput {
  count: number;

  type: GroundTransfersTravelerDetailsType;
}

export interface InsuranceShoppingRequestInput {
  /** Country code of user's residency - to be passed if akamai headers not present */
  countryCode?: string | null;
  /** Region code of user's residency - to be passed if akamai headers not present */
  regionCode?: string | null;
  /** TripId */
  tripId: Uuid;
  /** In order to ignore the caching at client level and make an actual shoppingcall version hash is changed in subsequent requests */
  versionHash?: string | null;
}

export interface InsuranceDetailPrimingRequestInput {
  /** Car request for insurance priming */
  carRequest: InsuranceDetailPrimingForCarInput;
}

export interface InsuranceDetailPrimingForCarInput {
  /** Identifier token for car inventory */
  carOfferToken: string;
  /** Encoded string having certain offer information shown on search page. Eg. priceShown, avg category price */
  continuationContextualId?: string | null;
  /** Drop-off location for car */
  dropOffLocation?: InsuranceLocationInput | null;
  /** Pick-up location for car */
  pickUpLocation: InsuranceLocationInput;
  /** Reward point selection on  Car offer */
  rewardPointsSelection?: InsuranceRewardsPointSelectionEnum | null;
  /** List of accessories added with Car */
  selectedAccessories?: string[] | null;
}

export interface InsuranceLocationInput {
  /** Region id */
  regionId: string;
  /** Search term */
  searchTerm: string;
}

export interface ActivityDateRangeInput {
  endDate: DateInput;

  startDate: DateInput;
}
/** Activity search region information */
export interface ActivityDestinationInput {
  /** Coordinates of the region, used for region (city or multicity) resolution */
  coordinates?: CoordinatesInput | null;
  /** activity id proposed for pinning on LX-SRP */
  pinnedActivityId?: string | null;
  /** activity id passed as a reference for activity recommendations on LX-IS */
  referencedActivityId?: string | null;
  /** Gaia region ID of the search */
  regionId?: string | null;
  /** Name of the region, used for fuzzy resolution */
  regionName?: string | null;
  /** Gaia Region Type denoted by regionId, example HOTEL OR CITY */
  regionType?: string | null;
}
/** Activity marketing information to identify sem/seo traffic */
export interface ActivityMarketingInfoInput {
  /** Marketing channel type code. */
  mctc?: number | null;
  /** field which identifies sem channel */
  sem?: string | null;
  /** field which identifies semdtl value */
  semdtl?: string | null;
}

export interface ActivityOfferFilterInput {
  selections?: ActivitySelectedValueInput[] | null;

  tickets?: ActivityTicketInput[] | null;
}

export interface ActivitySelectedValueInput {
  id: string;

  value: string;
}

export interface ActivityTicketInput {
  code: string;

  count: number;
}
/** Separate a large list of results into multiple sublists */
export interface PaginationInput {
  /** Number of results to get past the starting index */
  size?: number | null;
  /** The inclusive 0-based starting index of the results. Defaults to 0 */
  startingIndex?: number | null;
}
/** Activity search filtering options */
export interface ActivitySearchFiltersInput {
  /** Filter results by user selected activity id from ESS activity Typeahead Suggestions. */
  activityId?: string | null;
  /** Filter results by activity category, supported with legacy categories */
  categories?: ActivityCategory[] | null;
  /** Filter results by activity category keys, supported with nested categories */
  categoryKeys?: string[] | null;
  /** Filter results by user provided free text search keyword */
  keyword?: string | null;
  /** Filter results by user regionId to support neighborhood filters */
  regionId?: string | null;
  /** Value selected by the userE.g.1. 'sort':'RECOMMENDED'2. 'slimSearchKeyword':'<KEYWORD ENTERED BY USER>'4. 'categories': 'ToursSightseeing' */
  selections?: ActivitySelectedValueInput[] | null;
}
/** Input argument for Request Context */
export interface ClientRequestInput {
  /** Headers of HTTP Request */
  headers: HttpHeaderInput[];
  /** Remote address of HTTP Request */
  remoteAddress: string;
  /** URL of HTTP Request */
  url: string;
}

export interface HttpHeaderInput {
  name: string;

  values: string[];
}
/** All criteria needed for a multi-item search */
export interface MultiItemSearchContextInput {
  cars?: CarSearchCriteriaInput[] | null;

  flights?: FlightSearchCriteriaInput[] | null;

  properties?: PropertySearchCriteriaInput[] | null;
}
/** Car criteria needed to perform a car search */
export interface CarSearchCriteriaInput {
  primary: PrimaryCarCriteriaInput;

  secondary?: ShoppingSearchCriteriaInput | null;
}
/** All criteria needed to perform a flight search */
export interface FlightSearchCriteriaInput {
  primary: PrimaryFlightCriteriaInput;

  secondary?: ShoppingSearchCriteriaInput | null;
}
/** Represents the core criteria needed for a flight search */
export interface PrimaryFlightCriteriaInput {
  journeyCriterias: FlightsJourneyCriteriaInput[];

  searchPreferences?: FlightsSearchPreferencesInput | null;

  travelers: TravelerDetailsInput[];

  tripType: FlightsTripType;
}
/** The input object for flights search */
export interface FlightsJourneyCriteriaInput {
  /** Arrival date of the flight */
  arrivalDate?: DateInput | null;
  /** Departure date of the flight */
  departureDate: DateInput;
  /** Three letter code of the destination airport */
  destination: string;
  /** # Deprecated: Please use cabinClass in FlightsSearchPreferences */
  flightsCabinClass?: FlightsCabinClass | null;
  /** Three letter code of the origin airport */
  origin: string;
}
/** Primary flights criteria part of the search wizard that have an impact on thefirst results set.It's different from the side filter part of the secondarysearch criteria that are filtering on top of it. The side filter should be usinga server driven approach. */
export interface FlightsSearchPreferencesInput {
  /** Advanced filters like non-stop, refundable */
  advancedFilters?: FlightsAdvancedFilterType[] | null;

  airline?: string | null;

  cabinClass: FlightsCabinClass;
}
/** Represents the traveler details */
export interface TravelerDetailsInput {
  age?: number | null;

  type: TravelerDetailsType;
}
/** Property criteria needed to perform a property search */
export interface PropertySearchCriteriaInput {
  primary: PrimaryPropertyCriteriaInput;

  secondary?: ShoppingSearchCriteriaInput | null;
}
/** The core criteria needed for a property search */
export interface PrimaryPropertyCriteriaInput {
  dateRange?: PropertyDateRangeInput | null;

  destination: DestinationInput;

  rooms: RoomInput[];
}

export interface PropertyDateRangeInput {
  checkInDate: DateInput;

  checkOutDate: DateInput;
}
/** Contains detailed geographic information like the Gaia region id as well as theproperty ids in the region for the property destination */
export interface DestinationInput {
  /** The Geo location of the region to search */
  coordinates?: CoordinatesInput | null;
  /** The property ID to use for region resolution (pinned search). */
  pinnedPropertyId?: string | null;
  /** List of property IDs to return search information for. */
  propertyIds?: string[] | null;
  /** The Gaia region ID of the search */
  regionId?: string | null;
  /** The name of the region ID, used for fuzzy resolution */
  regionName?: string | null;
}
/** A single hotel room configuration */
export interface RoomInput {
  /** The number of adult in the room */
  adults: number;
  /** The number of children in the room */
  children?: ChildInput[] | null;
}
/** A guest over the age of 2 */
export interface ChildInput {
  /** The child's age in years */
  age: number;
}
/** All natural keys for the products that the customer has already selected on the shopping path */
export interface MultiItemProductsInput {
  activities?: ActivityNaturalKeyInput[] | null;

  cars?: CarNaturalKeyInput[] | null;

  flights?: FlightNaturalKeyInput[] | null;

  properties?: PropertyNaturalKeyInput[] | null;
}
/** Minimum set of data used to retrieve details about an activity product */
export interface ActivityNaturalKeyInput {
  offerToken: string;

  productToken: string;
}
/** Minimum set of data used to retrieve details about a car product */
export interface CarNaturalKeyInput {
  offerToken: string;

  specialEquipments?: SpecialEquipment[] | null;
}
/** Minimum set of data used to retrieve details about a flight product */
export interface FlightNaturalKeyInput {
  offerToken: string;

  productTokens: string[];

  travelers: TravelerDetailsInput[];
}
/** Minimum set of data used to retrieve details about a property product */
export interface PropertyNaturalKeyInput {
  checkIn: DateInput;

  checkOut: DateInput;

  id: string;

  inventoryType: InventoryType;

  noCreditCard?: boolean | null;

  ratePlanId: string;

  ratePlanType?: string | null;

  roomTypeId: string;

  rooms: PropertyRoomInput[];

  shoppingPath?: ShoppingPathType | null;
}
/** Indicates how many rooms will be occupied and by whom */
export interface PropertyRoomInput {
  childAges: number[];

  numberOfAdults: number;
}
/** Represent the current location of the User so we can propose an origin for the flights */
export interface CrossSellUserLocationInput {
  /** The city of User's current location. ex: SANJOSE */
  city: string;
  /** The continent code of User's current location. ex: NA */
  continent: string;
  /** The country code of User's current location. ex: US */
  country: string;
  /** The region or state code of User's current location. ex: CA */
  region: string;
}
/** Represents the base product price */
export interface BrandedDealProductPriceInput {
  base: MoneyInput;

  taxesAndFees: MoneyInput;
}
/** Pricing information */
export interface MoneyInput {
  /** Numeric portion of the price */
  amount: number;
  /** The ISO 4217 3-letter code for this currency eg: USD EUR GBP ... */
  currency?: string | null;
}

export interface ShoppedProductInput {
  products: MultiItemProductsInput;

  shoppingPath: ShoppingPathType;
}
/** Contains necessary data for fetching property content */
export interface MishopDetailsUiPropertyContentPrimerInput {
  naturalKey: PropertyNaturalKeyInput;

  propertyChangeLink?: string | null;
}

export interface CruiseRequestContextInput {
  /** Cruise features enum to be passed down to cruise supply services as a header value */
  cruiseFeatures?: CruiseFeaturesInput | null;
  /** Default current to be used. If not set, cruise api will fall back to USD */
  defaultCurrency?: string | null;
  /** Inventory is striped by an optional franchise model key. More info here: https://confluence.expedia.biz/display/EWECruise/Design%3A+Franchise+Model+Key+Management */
  franchiseModelKey?: string | null;
  /** Flag that is set when the user is shopping as an agent from Partner Central */
  isAgent?: boolean | null;
}

export interface CruiseFeaturesInput {
  /** Header values to pass feature flags down to cruise supply services separated by pipes */
  features: CruiseFeature[];
}
/** Property search filtering options */
export interface PropertySearchFiltersInput {
  /** Filter results by available accessibility amenities. Example: [ROLL_IN_SHOWER]will return properties with a roll in shower */
  accessibility?: PropertyFilterAccessibility[] | null;
  /** Filter results by TAAP Agency business model. */
  agencyBusinessModels?: AgencyBusinessModel[] | null;
  /** Filter results by available amenities. Example: [POOL,WIFI] will return properties with a pool and wifi */
  amenities?: PropertyFilterAmenity[] | null;
  /** Filter results by the bedroom count. Only includes Vacation Rentals */
  bedroomFilter?: number[] | null;
  /** Filter results by chain id. Input supports a valid chain id */
  chain?: string | null;
  /** Filter results by property cleanliness attribute */
  cleaningAndSafetyPractices?: CleaningAndSafetyPractice[] | null;
  /** Filter results by TAAP commission tier. */
  commissionTiers?: CommissionTier[] | null;
  /** Filter results by Deals */
  deals?: DealType[] | null;
  /** Filter results by available meal plan. Example: FULL_BOARD will return properties with a full board */
  mealPlan?: MealPlanFilterAmenity[] | null;
  /** Filter results by neighborhood. Input supports a valid GAIA ID */
  neighborhood?: string | null;
  /** Filter results by the payment type. */
  paymentType?: PaymentType[] | null;
  /** Filter results by popular location. Input supports a valid coordinates combination string */
  poi?: string | null;
  /** Filter results by price. Can provide a min only, a max only, or a range. */
  price?: PriceRangeInput | null;
  /** PWA ONLY: Support for legacy PWA price buckets in the url. Use 'price' instead */
  priceBuckets?: number[] | null;
  /** Filter results by user provided string */
  propertyName?: string | null;
  /** Property syle filters */
  propertyStyles?: PropertyStyle[] | null;
  /** Filter results by average guest rating. Can provide a min only, a max only, or a range. */
  reviewScore?: ReviewScoreRangeInput | null;
  /** Rewards Type filters */
  rewards?: string[] | null;
  /** Filter results by availability */
  showAvailableOnly?: boolean | null;
  /** Filter results by property star rating. Example: 30, 50 returns properties rated 3 to 3.9 and 5 to 5.9 */
  starList?: number[] | null;
  /** Filter results by property star rating. Example: THREE returns properties rated 3.0+ */
  stars?: StarRangeInput | null;
  /** Filter results by structure type. Example: HOTEL returns properties of structure type 'HOTEL' */
  structureTypes?: StructureType[] | null;
  /** An SEM theme that needs to be passed through to other services */
  theme?: string | null;
  /** Filter results by the type of traveler. */
  travelerType?: TravelerType[] | null;
  /** Filter results by VIP only properties */
  vipOnly?: boolean | null;
}
/** Represents a range of prices for filtering properties. Follows currency rules of the user's point of sale */
export interface PriceRangeInput {
  /** The maximum price, e.g. 500.00 */
  max?: number | null;
  /** The minimum price, e.g. 50.00 */
  min?: number | null;
}
/** Represents a range of review scores for filtering properties */
export interface ReviewScoreRangeInput {
  /** The maximum review score, e.g. 5.0 */
  max?: number | null;
  /** The minimum review score, e.g. 1.0 */
  min?: number | null;
}

export interface StarRangeInput {
  max?: number | null;

  min?: number | null;
}
/** Container of all the marketing data */
export interface PropertyMarketingInfoInput {
  /** Meta affcid channel code */
  affcid?: string | null;
  /** Meta afflid channel code */
  afflid?: string | null;
  /** Meta afmcid channel code */
  afmcid?: string | null;
  /** Meta brandcid channel code */
  brandcid?: string | null;
  /** Meta emlcid channel code */
  emlcid?: string | null;
  /** Meta emldtl channel code */
  emldtl?: string | null;
  /** Meta gclid channel code */
  gclid?: string | null;
  /** Meta icmcid channel code */
  icmcid?: string | null;
  /** Meta icmdtl channel code */
  icmdtl?: string | null;
  /** Meta k_user_id channel code */
  k_user_id?: string | null;
  /** Meta kword channel code */
  kword?: string | null;
  /** Meta lnkloc channel code */
  lnkloc?: string | null;
  /** A consolidated list of marketing channels in key/value pairs.Example: [{"key": "mctc", "value": "2"}, {"key": "icmdtl", "value": "some values"}] */
  marketingChannels?: PropertyMarketingTagInput[] | null;
  /** A consolidated list of marketing prices in key/value pairs.Example: [{"key": "exp_dp", "value": "100"}, {"key": "exp_tx", "value": "10"}] */
  marketingPrices?: PropertyMarketingTagInput[] | null;
  /** Marketing Channel Type Code: Indicates traffic type, i.e. 5 for Trivago */
  mctc?: number | null;
  /** Meta mdpcid channel code */
  mdpcid?: string | null;
  /** Meta mdpdtl channel code */
  mdpdtl?: string | null;
  /** Meta olacid channel code */
  olacid?: string | null;
  /** Meta oladtl channel code */
  oladtl?: string | null;
  /** Meta semcid channel code */
  semcid?: string | null;
  /** Meta semdtl channel code */
  semdtl?: string | null;
  /** Meta seocid channel code */
  seocid?: string | null;
}
/** An object with simple key/value combination for a marketing channel or price.Example: {"key": "mctc", "value": "3"} */
export interface PropertyMarketingTagInput {
  key: string;

  value: string;
}
/** The offer details from the search results page */
export interface SearchOfferInput {
  /** The price of the search results offer */
  offerPrice?: SearchOfferPriceInput | null;

  ratePlanId?: string | null;

  roomTypeId?: string | null;
}
/** The offer price from the search results page */
export interface SearchOfferPriceInput {
  /** The encoded multi-item price token */
  multiItemPriceToken?: string | null;
  /** The timestamp of when the SRP offer price was generated */
  offerTimestamp?: string | null;
  /** The total price of the search offer */
  price?: MoneyInput | null;
}
/** Data used for travelAd click tracking */
export interface PropertyTravelAdTrackingInfoInput {
  beaconIssued?: string | null;

  candidateHmGuid?: string | null;

  position?: string | null;

  rank?: string | null;

  slots?: string | null;

  testVersionOverride?: string | null;

  trackingData: string;
}
/** [Optional] Review results filters */
export interface PropertyReviewFiltersInput {
  /** Filter review results by category */
  category?: PropertyReviewCategory | null;
  /** Include or disclude reviews that only have ratings */
  includeRatingsOnlyReviews?: boolean | null;
  /** Get reviews immediately when true (without 90 days syndication) */
  includeRecentReviews?: boolean | null;
  /** Filter reviews by specified languages by receiving lang code e.g. 'en' */
  language?: string | null;
  /** Filter review results by reviewers' locale. Example: ko_KR returns reviews made by users on Korea POSa */
  locale?: Locale | null;
  /** Filter review results by a list of review ratings */
  ratings?: number[] | null;
  /** Filter review results by review type: POSITIVE or CRITICAL */
  reviewType?: PropertyReviewType | null;
  /** Filter review results by room type */
  roomTypeId?: number | null;
  /** Filter review results by user provided keyword */
  searchTerm?: string | null;
  /** Sort reviews by Recency, high-to-low rating and low-to-high rating */
  sortRating?: string[] | null;
  /** Filter review results by travel companions */
  travelCompanion?: string[] | null;
  /** Filter reviews by tripReason and travelerCompanion depending on this list */
  travelerType?: string[] | null;
  /** Filter review results by trip reasons */
  tripReason?: string[] | null;
}
/** PWA ONLY: Input that is sent directly from the URL value. These inputs can notbe parsed on a server render of the PWA and must be converted in the spinner */
export interface LegacyPropertySearchCriteriaInput {
  /** Maps to PropertyFilterAmenity */
  amenities?: string[] | null;
  /** Maps to ReviewScoreRange */
  guestRating?: string | null;
  /** Maps to PaymentType enum to account for legacy URL values */
  paymentType?: string[] | null;
  /** List of the price buckets to use. Starts from 0 index e.g. `[0,1,2]` */
  priceBuckets?: number[] | null;
  /** User preference for tracking which is only required in POSs that require tracking opt in */
  privacyTrackingState?: PrivacyTrackingState | null;
  /** Maps to PropertySort */
  sort?: string | null;
  /** Maps to starList */
  stars?: string | null;
  /** Maps to StructureType */
  structureTypes?: string[] | null;
}
/** Property shop options; If this field is not supplied, a server default will be chosen */
export interface PropertyShopOptionsInput {
  /** Ads related property search option */
  listings?: Listings | null;
  /** Paandi redirection to white label */
  paandiRedirection?: string | null;
  /** Points related property search option */
  points?: Points | null;
}
/** User Intent corresponding to this Search */
export interface SearchIntentInput {
  /** list of interests coming from Customer Spinner */
  interests?: InterestInput[] | null;
  /** SEM param, fetch from URL */
  semDtl?: string | null;
  /** SEM param, fetch from URL */
  semdtl?: string | null;
  /** TEMP Theme param, fetch from URL. Remove after SEM migration is complete */
  theme?: string | null;
  /** TEMP intent param, fetch from URL. Support BFF while migration to BEX API */
  userIntent?: string | null;
}
/** Provides the interest of a Customer for a particular search */
export interface InterestInput {
  /** SEM id of interest */
  desmetId?: string | null;
  /** Name of interest */
  name?: string | null;
}
/** Optional information to get a better contextual customer notification */
export interface CustomerNotificationOptionalContextInput {
  /** itinerary number */
  itineraryNumber?: string | null;
  /** list of journey criteria items */
  journeyCriterias?: CustomerNotificationOptionalContextJourneyCriteriaInput[] | null;
  /** the optional URL input field to retrieve extra url information, such as deeplinking url for the mobile app download notification */
  referer?: Url | null;
  /** regionId number */
  regionId?: string | null;
  /** list of GAIA regionIds */
  regionIds?: string[] | null;
  /** trip folder id */
  tripFolderId?: string | null;
}
/** Journey criteria such as location gaia id and travel date ranges */
export interface CustomerNotificationOptionalContextJourneyCriteriaInput {
  /** start date and end date of the trip */
  dateRange?: DateRangeInput | null;
  /** destination information */
  destination?: CustomerNotificationOptionalContextJourneyCriteriaLocationInput | null;
  /** origin information */
  origin?: CustomerNotificationOptionalContextJourneyCriteriaLocationInput | null;
}
/** A range of dates, from a starting date to an ending date */
export interface DateRangeInput {
  /** The terminal date in this range */
  end: DateInput;
  /** The starting date in this range */
  start: DateInput;
}
/** Journey criteria such as location gaia id and travel date ranges */
export interface CustomerNotificationOptionalContextJourneyCriteriaLocationInput {
  /** airport code */
  airportTLA?: string | null;
  /** property id */
  propertyId?: string | null;
  /** regionId number */
  regionId?: string | null;
}
/** Filter criteria details for the searchHistory query. */
export interface SearchHistoryFilterCriteriaInput {
  /** Search item end date in yyyy-MM-dd format. */
  endDate: string;
  /** Search item regionId. */
  regionId: string;
  /** Search item region type. */
  regionType?: string | null;
  /** Search item start date in yyyy-MM-dd format. */
  startDate: string;
}
/** Criteria based on search history groups are created. */
export interface SearchHistoryGroupingCriteriaInput {
  /** Search history grouping based on specified day range. */
  dayRange?: SearchHistoryDayRange | null;
  /** Search history grouping based on specified destination type. */
  destinationType?: SearchHistoryDestinationType | null;
}
/** Represents criteria for flights information page. */
export interface FlightsDetailComponentsCriteriaInput {
  /** Represents FlightsSearchContext of the selected flight */
  flightsSearchContext: FlightsSearchContextInput;
  /** Represents FlightsJourneyCriteria of the selected flight */
  journeyCriteria: FlightsJourneyCriteriaInput[];
  /** Represents Air Offer Token of the selected flight */
  journeyIdentifier: string;
  /** Represents Price of the selected flight */
  originalPrice?: MoneyInput | null;
  /** Represents QueryParams of the selected flight */
  queryParams?: GraphQlPairInput[] | null;
  /** Represents FlightsSearchPreferences of the selected flight */
  searchPreferences?: FlightsSearchPreferencesInput | null;
  /** Represents FlightsTravelerDetails of the selected flight */
  travelerDetails: FlightsTravelerDetailsInput[];
}
/** Context for flights search */
export interface FlightsSearchContextInput {
  /** Represent the continuation identifier for spinner to deduce which all journeyshave been selected. Null value represents the request is for first journey. */
  journeysContinuationId?: string | null;
  /** Represents the flights user selected for each segment when the user proceededto FIS.This node will be populated on the search response only if customer isreturning to FSR from FIS. */
  previousFlightSelections?: JourneyFlightSelectionInput[] | null;
  /** Trip type in search */
  tripType: FlightsTripType;
}
/** Represents a pair of segment order as index and the flight identifier as value */
export interface JourneyFlightSelectionInput {
  /** Represents the segment index. */
  journeyIndex: number;
  /** Represents the flight combination the customer previously selected for theindexed segment. This will be used to highlight the previously selected offerfor pinned listing. */
  offerIdentifier: string;
}
/** An object with simple key/value combination. This can be used to representgeneric input where you do not know all the values that can be provided.It should be avoided in favor of a strict type with set fields, but can be useful in specific situations. */
export interface GraphQlPairInput {
  key: string;

  value: string;
}
/** Traveler details for flights search */
export interface FlightsTravelerDetailsInput {
  /** Age for each traveler */
  ages?: number[] | null;
  /** Traveler count */
  count: number;
  /** Traveler type */
  travelerType: FlightsTravelerType;
}
/** Represents criteria for flights information page. */
export interface FlightsDetailCriteriaInput {
  /** Represent the continuation identifier for spinner to deduce all journeys selected by the user. */
  journeyContinuationId: string;
}
/** Represents flights component display values */
export interface FlightsDisplayComponentValuesInput {
  /** Represents counting values of flights display component */
  displayCountingValues?: FlightsDisplayComponentCountingValueInput[] | null;
}
/** Represents display count of a component within a session e.g How many time NFF shows consecutively */
export interface FlightsDisplayComponentCountingValueInput {
  /** Represents display count of a flights component */
  displayCount: number;

  flightsDisplayComponent: FlightsDisplayComponent;
}

export interface FlightsSearchComponentCriteriaInput {
  /** Represents Unresolved list of params for meta. Like MDPCID, etc. */
  queryParams?: GraphQlPairInput[] | null;
}
/** Represents an element of the list which the client needs to send back to theserver as part of the request. This will be part of each FilterItem so clientneed not apply any logic on filter selection but simply add this to the next request */
export interface FlightsSearchFilterValuesInput {
  /** Represents the value associated with arrival airport filter. */
  arrivalAirportCodeFilterValue?: FlightsAirportCodeFilterValueInput | null;
  /** Represents the FilterValue object corresponding to the Arrival Time filter. */
  arrivalTimeFilterValue?: FlightsTimeBasedFilterValueInput | null;
  /** Represents the value associated with departure airport filter. */
  departureAirportCodeFilterValue?: FlightsAirportCodeFilterValueInput | null;
  /** Represents the FilterValue object corresponding to the Departure Time filter. */
  departureTimeFilterValue?: FlightsTimeBasedFilterValueInput | null;
  /** Represents the FilterValue object corresponding to the Duration filter. */
  durationFilterValue?: FlightsDurationBasedFilterValueInput | null;
  /** Represents the value associated with flexible change policies filter. */
  flexibleChangePolicyBasedFilterValue?: FlightsFlexibleChangePolicyBasedFilterValueInput | null;
  /** Represents the FilterValue object corresponding to the Number of stops filter. */
  numOfStopFilterValue?: FlightsStopBasedFilterValueInput | null;
  /** Represents the FilterValue object corresponding to the Preferred Airline filter. */
  preferredAirlineFilterValue?: FlightsPreferredAirlineFilterValueInput | null;
}
/** Represents the value associated with airport filter */
export interface FlightsAirportCodeFilterValueInput {
  airportCode: string;
}
/** Represents the value associated with any time based filter, like DepartureTime or ArrivalTime based filter */
export interface FlightsTimeBasedFilterValueInput {
  timeOfDay: FlightsTimeOfDay;
}
/** Represents the value associated with duration based filter */
export interface FlightsDurationBasedFilterValueInput {
  maxDuration: number;
}
/** Represents the value associated with flexible change policies filter */
export interface FlightsFlexibleChangePolicyBasedFilterValueInput {
  policyName: FilterPolicyType;
}
/** Represents the value associated with number of stops based filter */
export interface FlightsStopBasedFilterValueInput {
  stopInfo: FlightsStopInfoInput;
}
/** Represents the stop related info for each number of stops based filter value.Combination of the number of stops and an operation.Ex. 2+ would be representedby {2,MORE_THAN} , 2 by {2,EQUAL} and <2 by {2,LESS_THAN} */
export interface FlightsStopInfoInput {
  numberOfStops: number;

  stopFilterOperation: FlightsStopFilterOperation;
}
/** Represents the value associated with preferred airline filter */
export interface FlightsPreferredAirlineFilterValueInput {
  carrierCode: string;
}
/** Represents the combination of SortType and SortOrder ex. Price Increasing */
export interface FlightsSortOptionTypeInput {
  sortOrder: FlightsSortOrder;

  sortType: FlightsSortType;
}

export interface PoiMapCoordinateInput {
  /** If present pins will be filtered out based on these categories */
  categories?: PoiMapItemCategory[] | null;
  /** Center coordinates to generate the map around it */
  centerCoordinates: CoordinatesInput;
  /** If present we will try to search POI based on end date */
  endDate?: DateInput | null;
  /** If present we will try to search POI based on start date */
  startDate?: DateInput | null;
  /** User pins with correct styling will be given back. Also the distance will be based on the first coordinate in the list */
  userCoordinates?: UserCoordinatesInput[] | null;
  /** If present this radius will be used to filter out pins */
  zoomRadius?: DistanceInput | null;
}

export interface UserCoordinatesInput {
  coordinates: CoordinatesInput;

  type: UserCoordinateType;
}
/** Measurable distance with units */
export interface DistanceInput {
  unit: DistanceUnit;

  value: number;
}
/** A location can be represented by a region id or an airport code. */
export interface InsightsLocationInput {
  /** Three letter IATA code associated with am airport near the location */
  airportCode?: string | null;
  /** Gaia region id of the location */
  regionId?: string | null;
}

export interface ShortlistDestinationFilterInput {
  /** Region type that will ultimately determined filtered results. Default is MULTI_CITY_VICINITY */
  destinationType: RegionType;
  /** Gaia region ID for which we want to filter shortlisted results. Does not haveto match region type, but will be used to find the relevant destination typebased on region type provided */
  regionId: string;
}

export interface CampaignParametersInput {
  campaignId: string;

  contentPagination?: ContentPaginationInput | null;

  propertyParameters?: CampaignPropertyParametersInput | null;
}

export interface ContentPaginationInput {
  pageNumber: number;

  pageSize?: number | null;
}

export interface CampaignPropertyParametersInput {
  guestRating?: number | null;

  propertyId: string;

  starRating?: number | null;

  type?: PropertyDetailsPropertyType | null;
}

export interface DestinationImageDimensionsInput {
  height: number;

  width: number;
}

export interface UserLocationInput {
  userCountryCode?: string | null;

  userLatitude?: BigDecimal | null;

  userLongitude?: BigDecimal | null;

  userSelectedOrigin?: string | null;
}
/** Question And Answer Search filters */
export interface ProductQuestionFiltersInput {
  /** Filter Questions and Answers on the basis of this keyword */
  searchTerm?: string | null;
}

export interface AbandonBookingInput {
  /** Order number of the booking for abandoning */
  orderNumber: string;
  /** Unique identifier of the collection of products / trip */
  tripId: Uuid;
}
/** Describes a coupon. Please provide a value to just one of the optional arguments. */
export interface CheckoutCouponInput {
  /** A coupon value entered by the user */
  code?: string | null;
  /** A coupon id value that the user selected from the list of available coupons */
  id?: string | null;
}

export interface BookingInput {
  cars?: BookingCarInput[] | null;
  /** Email required for booking information to be sent to */
  email: string;
  /** List of ways to pay for the booking. */
  paymentMethods: PaymentMethodInput[];

  properties?: BookingPropertyInput[] | null;
  /** Total price of the booking */
  totalPrice?: MoneyInput | null;
  /** Unique identifier of the collection of products / trip */
  tripId: Uuid;
  /** Encoded string representing the most up to date state of the trip. The valueto use can be found in the response of the checkout query. */
  tripState: string;
  /** Trust payload to send for fraud checking */
  trustPayload?: string | null;
}
/** Booking information regarding a car rental product */
export interface BookingCarInput {
  contactName: PersonNameInput;

  phoneNumber: PhoneNumberInput;
  /** The unique identifier of the product sometimes referred to as componentId /entityId. Used to identify a product in the TripService. */
  reference: string;
}
/** Name of the main traveler */
export interface PersonNameInput {
  firstName: string;

  lastName: string;
}
/** Phone number with prefix number */
export interface PhoneNumberInput {
  number: string;
  /** The ISO country code (e.g. 'USA', 'GBR', etc) */
  phoneCountryId: string;
}
/** Requires at least 1 payment method to be provided. Currently only supports Credit Card and single payment. */
export interface PaymentMethodInput {
  /** Amount of money to charge for this payment method, not providing this assumes full amount */
  amountToCharge: MoneyInput;
  /** Points information which will be used to pay for the booking */
  paymentPoints?: PaymentPointsInput | null;
  /** Payment token information which will be used to pay for the booking */
  paymentToken?: PaymentTokenInput | null;
  /** Type of the payment element */
  paymentType: PaymentMethodType;
}

export interface PaymentPointsInput {
  /** Payment instrument id for pay with points */
  id: string;
  /** Payment sub method for pay with points */
  paymentSubmethod: string;
  /** Whether points is used or not */
  usePoints: boolean;
}

export interface PaymentTokenInput {
  /** Payment session id for only 3DS booking */
  paymentSessionId?: string | null;
  /** When provided, will store the payment method for future use */
  saveAs?: string | null;
  /** Edge Token used for the payment */
  token: string;
  /** Type of payment being processed by the edge token */
  type: PaymentTokenType;
}
/** Booking information regarding a property product */
export interface BookingPropertyInput {
  contactName: PersonNameInput;

  phoneNumber: PhoneNumberInput;

  preferences?: PropertyPreferencesInput | null;
  /** The unique identifier of the product sometimes referred to as componentId /entityId. Used to identify a product in the TripService. */
  reference: string;
  /** Indicates whether the user wants to receive a confirmation sms or not. Default type is false. */
  sendConfirmationText?: boolean | null;
}
/** Outlines the user's requests and preferences to the property */
export interface PropertyPreferencesInput {
  /** List of user's accessibility requests */
  accessibilityRequests?: string[] | null;
  /** The user's requested bed type */
  bedType?: string | null;
  /** Indicates whether the user would prefer a smoking or non smoking room */
  smoking?: boolean | null;
  /** Free text special request to be conveyed to the property */
  specialRequests?: string | null;
}

export interface PaymentSessionCriteriaInput {
  /** Booking info which controls what kind of payment sessions may be required for payment */
  bookingProductInfoDetails: BookingProductDetailsInput[];
  /** Currency of the payment session */
  currency?: CurrencyInput | null;
  /** Payment token that represents the payment details */
  edgeToken: string;
  /** Browser metadata to set up 3DS */
  encodedBrowserMetadata: string;
  /** Trip ID to associate with the payment session */
  tripId: Uuid;
  /** Version of the library to use for challenge */
  version: string;
}

export interface BookingProductDetailsInput {
  businessModel: BusinessModel;

  lineOfBusiness: LineOfBusiness;
}
/** Information about a specific currency */
export interface CurrencyInput {
  /** The ISO 4217 3-letter code for this currency */
  code: string;
  /** The display name of the currency */
  name: string;
  /** The currency symbol, e.g. '$' */
  symbol: string;
}

export interface ResumeBookingInput {
  /** Order number of the booking for resuming */
  orderNumber: string;
  /** List of payment options used for the booking */
  paymentOptionsUsed: PaymentOptionType[];
  /** Unique identifier of the collection of products / trip */
  tripId: Uuid;
}
/** Points Input needed to update points */
export interface PointsInput {
  /** Actions that points can undertake, e.g. Apply/Remove */
  action: PayWithPointsUpdateAction;
  /** Unique identifier for the Trip */
  tripId: Uuid;
}

export interface AddInsuranceRequestInput {
  /** CountryCode from residency selection of user */
  countryCode?: string | null;
  /** The user selection for the Insurance product(s) */
  insuranceProductIds: string[];
  /** RegionCode from residency selection of user */
  regionCode?: string | null;
  /** The source id of the persistence store.For example Trip for BEX or Record locator for other systems */
  sourceId: string;
  /** The identifier to get the decoded value of params received in shopping response */
  updateRequestId: string;
}

export interface AddInsuranceRequestOldInput {
  insuranceSearchId: string;

  offerTypeId: number;
}

export interface InsuranceTripMutationRequestInput {
  action: InsuranceMutationType;

  insuranceSearchId?: string | null;

  offerTypeId?: number | null;
}

export interface RemoveInsuranceRequestInput {
  /** The user selection for the Insurance product(s) */
  insuranceProductIds: string[];
  /** The source id of the persistence store.For example Trip for BEX or Record locator for other systems */
  sourceId: string;
  /** The identifier to get the decoded value of params received in shopping response */
  updateRequestId: string;
}

export interface RemoveInsuranceRequestOldInput {
  insuranceSearchId: string;

  offerTypeId?: number | null;
}

export interface CartFlightSearchContextInput {
  /** The age of every children at the time of the flight */
  childAges: number[];
  /** Flight filters */
  filter?: CartFlightFilterInput | null;
  /** The list of infant(s) sitting on laps */
  infantsInLap: boolean[];
  /** The number of adults */
  numberOfAdults: number;
  /** List of origins and destinations flight components */
  originDestinations: CartOriginDestinationSearchInput[];
  /** The type of ticket searched */
  searchType: CartFlightSearchType;
}

export interface CartFlightFilterInput {
  /** non-stop flights only filter */
  nonStopOnly?: boolean | null;
  /** Preferred airline filter */
  preferredAirline?: string | null;
  /** Preferred class filter */
  preferredClass?: string | null;
  /** refundable flights only filter */
  refundableOnly?: boolean | null;
}

export interface CartOriginDestinationSearchInput {
  /** The departure date of the flight */
  departure: DateInput;
  /** The code (TLA) of the arrival airport */
  destinationAirportCode: string;
  /** The code (TLA) of the departure airport */
  originAirportCode: string;
}
/** Minimum set of data used to retrieve details about a property product */
export interface PropertyOfferInput {
  /** Sometimes, 1 room's offer needs to be represented by more than 1 Property Natural Key, e.g: Mixed Rate Plan */
  naturalKeys: PropertyNaturalKeyInput[];
  /** The index of the room user is adding */
  offerIndex: number;
}

export interface CartPropertySearchContextInput {
  /** The checking date for the property rental */
  checkIn: DateInput;
  /** The checkOut date for the property rental */
  checkOut: DateInput;
  /** The id of the region where the hotel is located - from lodging domain */
  regionId: string;
  /** The list of rooms that user searched for */
  rooms: PropertyRoomInput[];
}
/** Options for the session cart being created */
export interface CartOptionsInput {
  ttl: CartTtl;
}
/** Checkout option and its value to apply on the checkoutUrl */
export interface CheckoutOptionInput {
  type: CheckoutOptionType;

  value: string;
}
/** Represents the the user input for customer notification mutation */
export interface CustomerNotificationUserInput {
  /** Represents list of customer notification user input */
  inputs: CustomerNotificationUserInputElementInput[];
}
/** Represents customer notification user input */
export interface CustomerNotificationUserInputElementInput {
  /** Represents the type of customer notification user input */
  type: string;
  /** Represents the value of customer notification user input */
  value: string;
}
/** Represents the attributes on a notification that could be changed after an interaction */
export interface CustomerNotificationModifiableAttributesInput {
  /** Set to true when notification is dismissed */
  dismiss: boolean;
  /** Set to true when notification is read */
  read: boolean;
  /** Set to true when notification is seen */
  seen: boolean;
}
/** Key/Value pairs of data required by the client for playback. (Optional) */
export interface ShortlistMetadataInput {
  key: string;

  value: string;
}

// ====================================================
// Enums
// ====================================================

/** Specifies the behavior of ALTER, which is used to run Abacus experiments on localization messages. */
export enum AlterMode {
  DEBUG = "DEBUG",
  NONE = "NONE",
  PREVIEW = "PREVIEW",
  RELEASED = "RELEASED",
}
/** Valid device types */
export enum DeviceType {
  APP_PHONE = "APP_PHONE",
  APP_TABLET = "APP_TABLET",
  CHAT_APP = "CHAT_APP",
  DESKTOP = "DESKTOP",
  MOBILE_PHONE = "MOBILE_PHONE",
  MOBILE_TABLET = "MOBILE_TABLET",
  VOICE_APP = "VOICE_APP",
}

export enum AuthenticationState {
  ANONYMOUS = "ANONYMOUS",
  AUTHENTICATED = "AUTHENTICATED",
  IDENTIFIED = "IDENTIFIED",
}
/** Privacy tracking user preference. We can retrieve info on if the site allowstracking from Site Info and null can also be used to represent a selection or not */
export enum PrivacyTrackingState {
  CAN_NOT_TRACK = "CAN_NOT_TRACK",
  CAN_TRACK = "CAN_TRACK",
}

export enum BookingStatus {
  ABANDONED = "ABANDONED",
  ANY = "ANY",
  BOOKED = "BOOKED",
  CANCELLED = "CANCELLED",
  DELETED = "DELETED",
  EXPIRED = "EXPIRED",
  FAILED = "FAILED",
  INVALID = "INVALID",
  NO_LONGER_AVAILABLE = "NO_LONGER_AVAILABLE",
  PARTIALLY_FAILED = "PARTIALLY_FAILED",
  PENDING = "PENDING",
  PLANNING = "PLANNING",
  SAVED = "SAVED",
  UNKNOWN = "UNKNOWN",
}
/** supported sizes of icons */
export enum IconSize {
  EXTRA_SMALL = "EXTRA_SMALL",
  LARGE = "LARGE",
  MEDIUM = "MEDIUM",
  MEDIUM_LARGE = "MEDIUM_LARGE",
  SMALL = "SMALL",
}

export enum ChronoUnit {
  CENTURIES = "CENTURIES",
  DAYS = "DAYS",
  DECADES = "DECADES",
  ERAS = "ERAS",
  FOREVER = "FOREVER",
  HALFDAYS = "HALFDAYS",
  HOURS = "HOURS",
  MICROS = "MICROS",
  MILLENNIA = "MILLENNIA",
  MILLIS = "MILLIS",
  MINUTES = "MINUTES",
  MONTHS = "MONTHS",
  NANOS = "NANOS",
  SECONDS = "SECONDS",
  WEEKS = "WEEKS",
  YEARS = "YEARS",
}

export enum BooleanEnum {
  FALSE = "FALSE",
  TRUE = "TRUE",
}

export enum EventType {
  ItinActiveCar = "ItinActiveCar",
  ItinActiveCruise = "ItinActiveCruise",
  ItinActiveFlight = "ItinActiveFlight",
  ItinActiveGT = "ItinActiveGT",
  ItinActiveHotel = "ItinActiveHotel",
  ItinActiveLX = "ItinActiveLX",
  ItinActivePackageFH = "ItinActivePackageFH",
  ItinActiveRail = "ItinActiveRail",
  TripsHeroModuleCurrentTrip = "TripsHeroModuleCurrentTrip",
  TripsHeroModulePotentialTrip = "TripsHeroModulePotentialTrip",
  TripsHeroModuleUpcomingTrip = "TripsHeroModuleUpcomingTrip",
  TripsItemDetailViewed = "TripsItemDetailViewed",
  TripsListViewed = "TripsListViewed",
  TripsModuleDestinationGuide = "TripsModuleDestinationGuide",
  TripsOverviewViewed = "TripsOverviewViewed",
  Unknown = "Unknown",
}
/** Used to highlight or convey information. For example, positive messaging like free cancellation may be green. */
export enum TextTheme {
  NEGATIVE = "NEGATIVE",
  POSITIVE = "POSITIVE",
  PRIMARY = "PRIMARY",
  SECONDARY = "SECONDARY",
}
/** Used to highlight or convey information. For example, Payable amount in the price summary module of the checkout page. */
export enum TextWeight {
  BOLD = "BOLD",
  MEDIUM = "MEDIUM",
  REGULAR = "REGULAR",
}

export enum TripsButtonWidth {
  MATCH_PARENT_CONTAINER = "MATCH_PARENT_CONTAINER",
  WRAP_CONTENT = "WRAP_CONTENT",
}
/** UI Theme to be applied to a `UISectionContainer` or a `TripsSectionContainer`. */
export enum ContainerTheme {
  DEFAULT = "DEFAULT",
  IMPORTANT = "IMPORTANT",
}
/** The type of map marker */
export enum TripsMarkerType {
  ActivityEventMarker = "ActivityEventMarker",
  ActivityGuestPickupMarker = "ActivityGuestPickupMarker",
  ActivityLocationMarker = "ActivityLocationMarker",
  ActivityRedemptionMarker = "ActivityRedemptionMarker",
  AirportMarker = "AirportMarker",
  CarMarker = "CarMarker",
  CruiseMarker = "CruiseMarker",
  HotelMarker = "HotelMarker",
  PlaceMarker = "PlaceMarker",
}

export enum RewardsPointSelectionEnum {
  APPLY_REWARD_POINTS = "APPLY_REWARD_POINTS",
  DO_NOT_APPLY_REWARD_POINTS = "DO_NOT_APPLY_REWARD_POINTS",
}

export enum CarActionType {
  APPLY_LOYALTY_POINTS = "APPLY_LOYALTY_POINTS",
  CAR_MAP_MARKER = "CAR_MAP_MARKER",
  DISMISS = "DISMISS",
  FORM_SUBMISSION = "FORM_SUBMISSION",
  GO_BACK_TO_SEARCH = "GO_BACK_TO_SEARCH",
  GO_TO_CANCELLATION_POLICY = "GO_TO_CANCELLATION_POLICY",
  GO_TO_CHECKOUT = "GO_TO_CHECKOUT",
  GO_TO_CLEANLINESS_DIALOG = "GO_TO_CLEANLINESS_DIALOG",
  GO_TO_DETAILS = "GO_TO_DETAILS",
  GO_TO_PACKAGES = "GO_TO_PACKAGES",
  GO_TO_RECOMMENDED_SORT_FAQ = "GO_TO_RECOMMENDED_SORT_FAQ",
  GO_TO_SIGNIN = "GO_TO_SIGNIN",
  GO_TO_SIGNUP = "GO_TO_SIGNUP",
  LOAD_MORE = "LOAD_MORE",
  OPEN_DIALOG = "OPEN_DIALOG",
  OPEN_INLINE_WIZARD = "OPEN_INLINE_WIZARD",
  OPEN_NEW_TAB = "OPEN_NEW_TAB",
  OPEN_ON_CURRENT_TAB = "OPEN_ON_CURRENT_TAB",
  OPEN_TEL = "OPEN_TEL",
  REFRESH = "REFRESH",
  REMOVE_LOYALTY_POINTS = "REMOVE_LOYALTY_POINTS",
  SEE_CARS_AT_MAP_MARKER = "SEE_CARS_AT_MAP_MARKER",
  SHARE_FEEDBACK = "SHARE_FEEDBACK",
  SHOW_AARP_EXCLUSIVE_OFFERS = "SHOW_AARP_EXCLUSIVE_OFFERS",
  SHOW_FREE_CANCELLATION_OFFERS = "SHOW_FREE_CANCELLATION_OFFERS",
  UNLOCK_CAR_SALES = "UNLOCK_CAR_SALES",
}

export enum CarsDialogType {
  LIMITED_RESULTS = "LIMITED_RESULTS",
}

export enum CarsRichTextStyle {
  BOLD = "BOLD",
  BULLET = "BULLET",
  ITALICIZE = "ITALICIZE",
}

export enum CarAccessorySelectionState {
  NOT_SELECTED = "NOT_SELECTED",
  SELECTED = "SELECTED",
}

export enum CarMapMarkerType {
  CarMarker = "CarMarker",
  PlaceMarker = "PlaceMarker",
}

export enum PackageType {
  FLIGHT_CAR = "FLIGHT_CAR",
  FLIGHT_HOTEL = "FLIGHT_HOTEL",
  FLIGHT_HOTEL_CAR = "FLIGHT_HOTEL_CAR",
  HOTEL_CAR = "HOTEL_CAR",
}

export enum CarRouteType {
  ONEWAY = "ONEWAY",
  ROUNDTRIP = "ROUNDTRIP",
}

export enum CarLabelTheme {
  CLICKABLE = "CLICKABLE",
}

export enum CheckoutUiActionType {
  INSURANCE = "INSURANCE",
  PAGE_LOAD = "PAGE_LOAD",
  SIGN_IN = "SIGN_IN",
}
/** Represents the size of a Text element */
export enum CheckoutTextSize {
  LARGE = "LARGE",
  REGULAR = "REGULAR",
  SMALL = "SMALL",
}

export enum PaymentOptionType {
  CREDIT_CARD = "CREDIT_CARD",
  PAYPAL = "PAYPAL",
  POINTS = "POINTS",
  STORED_CARD = "STORED_CARD",
}
/** Enum representing the size options for the UITK PaymentType element */
export enum PaymentTypeLogoSize {
  LARGE = "LARGE",
  SMALL = "SMALL",
}
/** Business model for a product */
export enum BusinessModel {
  CLASSIC_AGENCY = "CLASSIC_AGENCY",
  DIRECT_AGENCY = "DIRECT_AGENCY",
  MERCHANT = "MERCHANT",
}

export enum LineOfBusiness {
  HOTEL = "HOTEL",
  INSURANCE = "INSURANCE",
}

export enum ThreeDSv2InventoryType {
  LOCAL_INVENTORY = "LOCAL_INVENTORY",
}

export enum PenaltyCollectionType {
  ONLINE_PENALTY_COLLECTION = "ONLINE_PENALTY_COLLECTION",
}
/** Possible direction types for ground transfers */
export enum GroundTransfersDirection {
  FROM_AIRPORT = "FROM_AIRPORT",
  ROUNDTRIP = "ROUNDTRIP",
  TO_AIRPORT = "TO_AIRPORT",
}
/** Possible direction types for ground transfers */
export enum GeoType {
  AIRPORT = "AIRPORT",
  DESTINATION = "DESTINATION",
  PROPERTY = "PROPERTY",
}
/** Possible traveler details types */
export enum GroundTransfersTravelerDetailsType {
  ADULT = "ADULT",
  CHILD = "CHILD",
  INFANT = "INFANT",
}
/** Text style to apply to text */
export enum GroundTransfersStyle {
  EMPHASISED = "EMPHASISED",
  POSITIVE = "POSITIVE",
  STANDARD = "STANDARD",
}

export enum GroundTransfersSectionStyle {
  BULLETED = "BULLETED",
  STANDARD = "STANDARD",
}

export enum GroundTransfersMapTransitOption {
  BUS = "BUS",
  NONE = "NONE",
  TRAIN = "TRAIN",
}

export enum GroundTransfersMapTravelMode {
  DRIVING = "DRIVING",
  TRANSIT = "TRANSIT",
}

export enum GroundTransfersBadgeTheme {
  DEAL_BUNDLED = "DEAL_BUNDLED",
  DEAL_GENERIC = "DEAL_GENERIC",
  DEAL_MEMBER = "DEAL_MEMBER",
}

export enum GroundTransfersGroupViewType {
  CARDS_LIST = "CARDS_LIST",
}

export enum InsuranceMessageType {
  ERROR = "ERROR",
  INFO = "INFO",
  WARNING = "WARNING",
}

export enum InsuranceListLayout {
  SINGLE_COLUMN = "SINGLE_COLUMN",
}

export enum InsuranceListType {
  ORDERED = "ORDERED",
  UNORDERED = "UNORDERED",
}

export enum InsuranceRewardsPointSelectionEnum {
  APPLY_REWARD_POINTS = "APPLY_REWARD_POINTS",
  DO_NOT_APPLY_REWARD_POINTS = "DO_NOT_APPLY_REWARD_POINTS",
}

export enum InsurancePhrasePartStyle {
  COLOR_GREEN = "COLOR_GREEN",
  COLOR_RED = "COLOR_RED",
  EMPHASIS = "EMPHASIS",
  IMPORTANT = "IMPORTANT",
  STANDARD = "STANDARD",
}

export enum InsuranceListTypeOld {
  ICON = "ICON",
  NUMBERED = "NUMBERED",
}
/** Details view options that are not filters */
export enum ActivityDetailViewOptions {
  NON_CONSOLIDATED_OFFERS = "NON_CONSOLIDATED_OFFERS",
  SHOP_WITH_POINTS = "SHOP_WITH_POINTS",
}
/** Search options that are not filters */
export enum ActivitySearchOptions {
  CATEGORY = "CATEGORY",
  FILTER_NESTED_CATEGORIES = "FILTER_NESTED_CATEGORIES",
  GAIA_RETURN_ADDITIONAL_DISTANCE_PARAMETER = "GAIA_RETURN_ADDITIONAL_DISTANCE_PARAMETER",
  GIFTING_ACTIVITIES = "GIFTING_ACTIVITIES",
  GUEST_PROMO = "GUEST_PROMO",
  NON_CONSOLIDATED_OFFERS = "NON_CONSOLIDATED_OFFERS",
  SHOP_WITH_POINTS = "SHOP_WITH_POINTS",
  SHOW_GT_BANNER = "SHOW_GT_BANNER",
}

export enum ActivityBadgeType {
  CAMPAIGN_DEAL = "CAMPAIGN_DEAL",
  DEAL_ADD_ON = "DEAL_ADD_ON",
  DEAL_GENERIC = "DEAL_GENERIC",
  DEAL_MEMBER = "DEAL_MEMBER",
}

export enum ActivityCategory {
  ADULTS_ONLY_SHOWS = "ADULTS_ONLY_SHOWS",
  ADVENTURES = "ADVENTURES",
  ADVENTURE_OUTDOOR = "ADVENTURE_OUTDOOR",
  AIRBOAT_TOURS = "AIRBOAT_TOURS",
  AIRPLANE_RIDES = "AIRPLANE_RIDES",
  AIRPLANE_TOURS = "AIRPLANE_TOURS",
  AIRPORT_GROUND_TRANSPORTATION = "AIRPORT_GROUND_TRANSPORTATION",
  AIRPORT_LOUNGES = "AIRPORT_LOUNGES",
  AIRPORT_TO_AIRPORT_TRANSFERS = "AIRPORT_TO_AIRPORT_TRANSFERS",
  AIR_BALLOON_HELICOPTER_TOURS = "AIR_BALLOON_HELICOPTER_TOURS",
  AIR_HELICOPTER_BALLOON_TOURS = "AIR_HELICOPTER_BALLOON_TOURS",
  AMUSEMENT_THEME_PARKS = "AMUSEMENT_THEME_PARKS",
  ARCHITECTURE_TOURS = "ARCHITECTURE_TOURS",
  ART_CLASSES = "ART_CLASSES",
  ART_CULTURE_HISTORY_TOURS = "ART_CULTURE_HISTORY_TOURS",
  ART_MUSIC_LITERARYTOURS = "ART_MUSIC_LITERARYTOURS",
  ATTRACTIONS = "ATTRACTIONS",
  ATTRACTION_TICKETS = "ATTRACTION_TICKETS",
  BALLOON_RIDES = "BALLOON_RIDES",
  BALLOON_TOURS = "BALLOON_TOURS",
  BAR_PUB_TOURS = "BAR_PUB_TOURS",
  BEER_BREWERY_TOURS = "BEER_BREWERY_TOURS",
  BEYOND_THE_CITY = "BEYOND_THE_CITY",
  BIKE_MOUNTAIN_BIKE_TOURS = "BIKE_MOUNTAIN_BIKE_TOURS",
  BIKE_RENTALS = "BIKE_RENTALS",
  BOAT_RENTAL = "BOAT_RENTAL",
  BOAT_TOURS = "BOAT_TOURS",
  BOAT_TOURS_CRUISES = "BOAT_TOURS_CRUISES",
  BRUNCHC_RUISES = "BRUNCHC_RUISES",
  BUNGEE_JUMPING_SKYDIVING = "BUNGEE_JUMPING_SKYDIVING",
  BUS_MINIVAN_TOURS = "BUS_MINIVAN_TOURS",
  CABARET = "CABARET",
  CAMPAIGN_DEALS = "CAMPAIGN_DEALS",
  CASTLE_PALACE_TOURS = "CASTLE_PALACE_TOURS",
  CHAUFFER_SERVICES = "CHAUFFER_SERVICES",
  CHRISTMAS = "CHRISTMAS",
  CIRQUE = "CIRQUE",
  CIRQUE_DU_SOLEIL = "CIRQUE_DU_SOLEIL",
  CIRQUE_DU_SOLEILSHOWS = "CIRQUE_DU_SOLEILSHOWS",
  CITY_AND_ATTRACTION_TRANSFERS = "CITY_AND_ATTRACTION_TRANSFERS",
  CITY_ATTRACTION_TRANSFERS = "CITY_ATTRACTION_TRANSFERS",
  CITY_TOURS = "CITY_TOURS",
  CITY_TOURS_PACKAGES = "CITY_TOURS_PACKAGES",
  CLASSES_WORKSHOPS = "CLASSES_WORKSHOPS",
  CLUB_AND_PARTY_BUS_TOURS = "CLUB_AND_PARTY_BUS_TOURS",
  CLUB_PARTY_BUS_TOURS = "CLUB_PARTY_BUS_TOURS",
  COFFEE_TEA_TOURS = "COFFEE_TEA_TOURS",
  COMEDY_SHOWS = "COMEDY_SHOWS",
  CONCERTS_SPECIAL_EVENTS = "CONCERTS_SPECIAL_EVENTS",
  COOKING_CLASSES = "COOKING_CLASSES",
  CRUISES_BOAT_TOURS = "CRUISES_BOAT_TOURS",
  CRUISES_WATER_TOURS = "CRUISES_WATER_TOURS",
  CULTURAL_HERITAGE_EXPERIENCES = "CULTURAL_HERITAGE_EXPERIENCES",
  CUSTOM_PRIVATE_TOURS = "CUSTOM_PRIVATE_TOURS",
  DANCE_CLASSES = "DANCE_CLASSES",
  DAY_OF_THE_DEAD = "DAY_OF_THE_DEAD",
  DAY_SPAS = "DAY_SPAS",
  DAY_TRIPS = "DAY_TRIPS",
  DAY_TRIPS_EXCURSIONS = "DAY_TRIPS_EXCURSIONS",
  DINING_EXPERIENCES = "DINING_EXPERIENCES",
  DINNER_CRUISES = "DINNER_CRUISES",
  DINNER_THEATER = "DINNER_THEATER",
  DISNEY = "DISNEY",
  DISNEY_PARKS = "DISNEY_PARKS",
  DOLPHIN_WHALE_WATCHING = "DOLPHIN_WHALE_WATCHING",
  DOSE_OF_CULTURE = "DOSE_OF_CULTURE",
  DUCK_TOURS = "DUCK_TOURS",
  EASTER = "EASTER",
  FAMILY_FRIENDLY = "FAMILY_FRIENDLY",
  FASHION_SHOWS_TOURS = "FASHION_SHOWS_TOURS",
  FISHING_CHARTERS_TOURS = "FISHING_CHARTERS_TOURS",
  FISHING_TOURS_AND_CHARTERS = "FISHING_TOURS_AND_CHARTERS",
  FOOD_DRINK = "FOOD_DRINK",
  FOOD_DRINK_NIGHTLIFE = "FOOD_DRINK_NIGHTLIFE",
  FOOD_TOURS = "FOOD_TOURS",
  FUN_FOR_FOODIES = "FUN_FOR_FOODIES",
  FUN_ON_THE_WATER = "FUN_ON_THE_WATER",
  GALLERIES_MUSEUMS = "GALLERIES_MUSEUMS",
  GAMES_SHOWS_SPECIAL_EVENTS = "GAMES_SHOWS_SPECIAL_EVENTS",
  GETTING_AROUND = "GETTING_AROUND",
  GOLF_TEE_TIMES = "GOLF_TEE_TIMES",
  GOLF_TOURS_TEE_TIMES = "GOLF_TOURS_TEE_TIMES",
  HALLOWEEN = "HALLOWEEN",
  HAMMAMS_TURKISH_BATHS = "HAMMAMS_TURKISH_BATHS",
  HELICOPTER_RIDES = "HELICOPTER_RIDES",
  HELICOPTER_TOURS = "HELICOPTER_TOURS",
  HIGH_SPEED_DRIVING = "HIGH_SPEED_DRIVING",
  HIGH_SPEED_RIDES = "HIGH_SPEED_RIDES",
  HIKING_CAMPING = "HIKING_CAMPING",
  HISTORICAL_TOURS = "HISTORICAL_TOURS",
  HISTORY_CULTURE = "HISTORY_CULTURE",
  HOLIDAY_SEASONAL_TOURS = "HOLIDAY_SEASONAL_TOURS",
  HONEYMOON_PACKAGE = "HONEYMOON_PACKAGE",
  HONEYMOON_PACKAGES = "HONEYMOON_PACKAGES",
  HOP_ON_HOP_OFF = "HOP_ON_HOP_OFF",
  HOP_ON_HOP_OFF_TOURS = "HOP_ON_HOP_OFF_TOURS",
  HORSE_CARRIAGE_RIDES = "HORSE_CARRIAGE_RIDES",
  HOT_SPRINGS_THERMAL_SPAS = "HOT_SPRINGS_THERMAL_SPAS",
  INTERESTS = "INTERESTS",
  KAYAKING_CANOEING = "KAYAKING_CANOEING",
  LATEST_GREATEST = "LATEST_GREATEST",
  LIFT_TICKETS = "LIFT_TICKETS",
  LIKELY_TO_SELL_OUT = "LIKELY_TO_SELL_OUT",
  LITERARY_ART_MUSIC_TOURS = "LITERARY_ART_MUSIC_TOURS",
  LOCAL_EXPERT_PICKS = "LOCAL_EXPERT_PICKS",
  LUNCH_CRUISES = "LUNCH_CRUISES",
  MOTORCYCLE_SCOOTER_TOURS = "MOTORCYCLE_SCOOTER_TOURS",
  MOVIE_TV_TOURS = "MOVIE_TV_TOURS",
  MULTIDAY_CRUISES = "MULTIDAY_CRUISES",
  MULTI_DAY_EXTENDED_TOURS = "MULTI_DAY_EXTENDED_TOURS",
  MUSEUM_TICKETS = "MUSEUM_TICKETS",
  MUSEUM_TICKETS_PASSES = "MUSEUM_TICKETS_PASSES",
  MUST_SEE_SIGHTS = "MUST_SEE_SIGHTS",
  NA = "NA",
  NATIONAL_HOLIDAYS = "NATIONAL_HOLIDAYS",
  NEW = "NEW",
  NEWY_EARS = "NEWY_EARS",
  NIGHTLIFE = "NIGHTLIFE",
  NIGHTLIFE_PASSES = "NIGHTLIFE_PASSES",
  NIGHT_CRUISES = "NIGHT_CRUISES",
  NIGHT_TOURS = "NIGHT_TOURS",
  ONSENS = "ONSENS",
  OTHER_ANIMALS_ACTIVITIES = "OTHER_ANIMALS_ACTIVITIES",
  OTHER_ANIMAL_ACTIVITIES = "OTHER_ANIMAL_ACTIVITIES",
  OTHER_CLASSES = "OTHER_CLASSES",
  OTHER_OUTDOOR_ACTIVITIES = "OTHER_OUTDOOR_ACTIVITIES",
  OTHER_SEASONAL_EVENTS = "OTHER_SEASONAL_EVENTS",
  OTHER_TOURS = "OTHER_TOURS",
  OTHER_TRANSFERS = "OTHER_TRANSFERS",
  OTHER_TRANSPORTATION = "OTHER_TRANSPORTATION",
  OTHER_WATER_ACTIVITIES = "OTHER_WATER_ACTIVITIES",
  PHOTOGRAPHY_TOURS = "PHOTOGRAPHY_TOURS",
  PORT_TRANSFERS = "PORT_TRANSFERS",
  PRIVATE_CUSTOM_TOURS = "PRIVATE_CUSTOM_TOURS",
  PRIVATE_DAY_TRIPS = "PRIVATE_DAY_TRIPS",
  PRIVATE_TOURS = "PRIVATE_TOURS",
  PRIVATE_TRANSFERS = "PRIVATE_TRANSFERS",
  PURE_ROMANCE = "PURE_ROMANCE",
  RELIGIOUS_SPIRITUAL_TOURS = "RELIGIOUS_SPIRITUAL_TOURS",
  RIVER_HARBOUR_CRUISES = "RIVER_HARBOUR_CRUISES",
  ROMAN_STAYCATION = "ROMAN_STAYCATION",
  SAFARIS = "SAFARIS",
  SAILING_TRIPS = "SAILING_TRIPS",
  SCOOTER_RENTALS = "SCOOTER_RENTALS",
  SEGWAY_TOURS = "SEGWAY_TOURS",
  SHARED_TRANSFERS = "SHARED_TRANSFERS",
  SHARK_DIVING = "SHARK_DIVING",
  SHOPPING_FASHION = "SHOPPING_FASHION",
  SHOPPING_PASSES_OFFERS = "SHOPPING_PASSES_OFFERS",
  SHOPPING_TOURS = "SHOPPING_TOURS",
  SHORE_EXCURIONS = "SHORE_EXCURIONS",
  SHOWS_CONCERTS = "SHOWS_CONCERTS",
  SHOW_SPORT_TICKETS = "SHOW_SPORT_TICKETS",
  SIGHTSEEING_ATTRACTION_PASSES = "SIGHTSEEING_ATTRACTION_PASSES",
  SIGHTSEEING_CITY_PASSES = "SIGHTSEEING_CITY_PASSES",
  SIGHTSEEING_PASSES = "SIGHTSEEING_PASSES",
  SKIING_RENTALS = "SKIING_RENTALS",
  SKIP_THE_LINE_TOURS = "SKIP_THE_LINE_TOURS",
  SNORKELING_SCUBA_DIVING = "SNORKELING_SCUBA_DIVING",
  SNOWBOARDING_RENTALS = "SNOWBOARDING_RENTALS",
  SNOWMOBILE_TOURS = "SNOWMOBILE_TOURS",
  SNOWSHOEING = "SNOWSHOEING",
  SPA = "SPA",
  SPA_WELLNESS = "SPA_WELLNESS",
  SPEED_BOATS_JET_SKIS = "SPEED_BOATS_JET_SKIS",
  SPORTING_EVENTS_PACKAGES = "SPORTING_EVENTS_PACKAGES",
  SPORTS_PACKAGES = "SPORTS_PACKAGES",
  STAY_ACTIVE = "STAY_ACTIVE",
  SUBMARINE_TOURS = "SUBMARINE_TOURS",
  SUNSET_CRUISES = "SUNSET_CRUISES",
  SUPERNATURAL_TOURS = "SUPERNATURAL_TOURS",
  SUSTAINABLE_TOURS = "SUSTAINABLE_TOURS",
  SWIM_WITH_DOLPHINS = "SWIM_WITH_DOLPHINS",
  THEATER_SHOWS_MUSICALS = "THEATER_SHOWS_MUSICALS",
  THEME_PARKS = "THEME_PARKS",
  THEME_PARK_TICKETS_TOURS = "THEME_PARK_TICKETS_TOURS",
  THE_GREAT_OUTDOORS = "THE_GREAT_OUTDOORS",
  THRILL_SEEKER = "THRILL_SEEKER",
  TICKETS = "TICKETS",
  TOURS_ACTIVITIES = "TOURS_ACTIVITIES",
  TOURS_SIGHTSEEING = "TOURS_SIGHTSEEING",
  TRANSPORTATION_SERVICES = "TRANSPORTATION_SERVICES",
  TREAT_YOURSELF = "TREAT_YOURSELF",
  TUBING = "TUBING",
  UNIVERSAL_THEME_PARKS = "UNIVERSAL_THEME_PARKS",
  VALENTINES_DAY = "VALENTINES_DAY",
  WALKING_BIKE_TOURS = "WALKING_BIKE_TOURS",
  WALKING_TOURS = "WALKING_TOURS",
  WATERSKIING_WAKEBOARDING = "WATERSKIING_WAKEBOARDING",
  WATER_ACTIVITIES = "WATER_ACTIVITIES",
  WATER_PARKS = "WATER_PARKS",
  WEDDING_CEREMONIES = "WEDDING_CEREMONIES",
  WEDDING_HONEYMOON = "WEDDING_HONEYMOON",
  WEDDING_PACKAGES = "WEDDING_PACKAGES",
  WEDDING_SHONEYMOONS = "WEDDING_SHONEYMOONS",
  WHAT_TO_DO_WITH_GROUPS = "WHAT_TO_DO_WITH_GROUPS",
  WHAT_TO_DO_WITH_KIDS = "WHAT_TO_DO_WITH_KIDS",
  WHITE_WATER_RAFTING = "WHITE_WATER_RAFTING",
  WILDLIFE_NATURE = "WILDLIFE_NATURE",
  WINE_TASTING_WINERY_TOURS = "WINE_TASTING_WINERY_TOURS",
  WINTER_ACTIVITIES = "WINTER_ACTIVITIES",
  YOGA_CLASS = "YOGA_CLASS",
  YOGA_CLASSES = "YOGA_CLASSES",
  ZOO_TICKETS = "ZOO_TICKETS",
  ZOO_TICKETS_PASSES = "ZOO_TICKETS_PASSES",
}

export enum ActivityCancellationType {
  FREE_CANCELLATION = "FREE_CANCELLATION",
  NO_CANCELLATION = "NO_CANCELLATION",
}

export enum ActivityDiscountType {
  AIR_ATTACH_MIP = "AIR_ATTACH_MIP",
  AIR_HOTEL_ATTACH_MIP = "AIR_HOTEL_ATTACH_MIP",
  CAMPAIGN_DEAL = "CAMPAIGN_DEAL",
  FREE_ACTIVITY = "FREE_ACTIVITY",
  GUEST = "GUEST",
  HOTEL_ATTACH_MIP = "HOTEL_ATTACH_MIP",
  MOD = "MOD",
  STRIKE_OUT = "STRIKE_OUT",
}

export enum ActivityRedemptionType {
  PRINT = "PRINT",
  VOUCHER_LESS = "VOUCHER_LESS",
}

export enum ActivityTextSize {
  LARGE = "LARGE",
  MEDIUM = "MEDIUM",
  SMALL = "SMALL",
}
/** Activity Price types */
export enum ActivityPriceType {
  GROUP = "GROUP",
  NORMAL = "NORMAL",
  VOLUME_BASED = "VOLUME_BASED",
}

export enum ActivityOfferUdsToken {
  SELECTED = "SELECTED",
  UNSELECTED = "UNSELECTED",
}
/** Activity banner type */
export enum ActivityBannerType {
  ALERT = "ALERT",
  INFO = "INFO",
  SHOP_WITH_POINTS = "SHOP_WITH_POINTS",
}
/** Unique identifier for a message if one needs to identify the reason for the message creation */
export enum ActivityMessageType {
  ADDON = "ADDON",
  EARN_2X_REWARD_POINTS = "EARN_2X_REWARD_POINTS",
  GIFTING_LX_BANNER = "GIFTING_LX_BANNER",
  LOGIN = "LOGIN",
  SOURCED_CAMPAIGN = "SOURCED_CAMPAIGN",
  SUMMER_CAMPAIGN_PRIMARY = "SUMMER_CAMPAIGN_PRIMARY",
  SUMMER_CAMPAIGN_SECONDARY = "SUMMER_CAMPAIGN_SECONDARY",
}

export enum ActivityReviewSort {
  HIGHEST_TO_LOWEST_RATED = "HIGHEST_TO_LOWEST_RATED",
  LOWEST_TO_HIGHEST_RATED = "LOWEST_TO_HIGHEST_RATED",
  NEWEST_TO_OLDEST = "NEWEST_TO_OLDEST",
}

export enum ActivityGroupType {
  ACTIVITY_LIST = "ACTIVITY_LIST",
  ACTIVITY_MESSAGE = "ACTIVITY_MESSAGE",
  AVAILABLE_TODAY = "AVAILABLE_TODAY",
  CATEGORY = "CATEGORY",
  FILTERED_ACTIVITIES = "FILTERED_ACTIVITIES",
  INTERESTS = "INTERESTS",
  KEYWORD_SEARCH = "KEYWORD_SEARCH",
  MORE_ACTIVITIES = "MORE_ACTIVITIES",
  NEIGHBOURHOOD = "NEIGHBOURHOOD",
  PINNED_ACTIVITY = "PINNED_ACTIVITY",
  POI = "POI",
  RECOMMENDATIONS = "RECOMMENDATIONS",
  SLIM_CATEGORY = "SLIM_CATEGORY",
  SUB_CATEGORIES = "SUB_CATEGORIES",
  SUB_CATEGORY = "SUB_CATEGORY",
  TOP_ACTIVITIES = "TOP_ACTIVITIES",
  XSELL_RECOMMENDATIONS = "XSELL_RECOMMENDATIONS",
}

export enum ActivityGroupViewType {
  ACTIVITY_LIST = "ACTIVITY_LIST",
  ACTIVITY_SPANNED_TILE_LIST = "ACTIVITY_SPANNED_TILE_LIST",
  ACTIVITY_TILES_CAROUSEL = "ACTIVITY_TILES_CAROUSEL",
  CATEGORY_TILES_CAROUSEL = "CATEGORY_TILES_CAROUSEL",
  KEYWORD_SEARCH = "KEYWORD_SEARCH",
  MESSAGE = "MESSAGE",
  SLIM_CATEGORY_TILES_CAROUSEL = "SLIM_CATEGORY_TILES_CAROUSEL",
  TEXT = "TEXT",
}
/** Search view options that are not filters */
export enum ActivitySearchViewOptions {
  DISTANCE_FROM_HOTEL_TO_ACTIVITY = "DISTANCE_FROM_HOTEL_TO_ACTIVITY",
  FILTER_NESTED_CATEGORIES = "FILTER_NESTED_CATEGORIES",
  NEARBY_ACTIVITIES = "NEARBY_ACTIVITIES",
  SHOP_WITH_POINTS = "SHOP_WITH_POINTS",
  SHOW_GT_BANNER = "SHOW_GT_BANNER",
  TRAVEL_DISTANCE_FROM_HOTEL = "TRAVEL_DISTANCE_FROM_HOTEL",
}
/** Activity sort types */
export enum ActivitySort {
  CAMPAIGN_DEALS = "CAMPAIGN_DEALS",
  DISTANCE_FROM_HOTEL = "DISTANCE_FROM_HOTEL",
  PRICE_HIGH_TO_LOW = "PRICE_HIGH_TO_LOW",
  PRICE_LOW_TO_HIGH = "PRICE_LOW_TO_HIGH",
  RECOMMENDED = "RECOMMENDED",
}

export enum ActivityMapGroupType {
  POI = "POI",
}

export enum ActivityCategoryType {
  ACTIVITIES = "ACTIVITIES",
  CATEGORIES = "CATEGORIES",
  DEALS_PROMOTIONS = "DEALS_PROMOTIONS",
  NA = "NA",
  RECOMMENDATIONS = "RECOMMENDATIONS",
  TOURS = "TOURS",
  TRANSPORTATION = "TRANSPORTATION",
}

export enum ActivityUdsToken {
  MULTI_SELECT_LIST = "MULTI_SELECT_LIST",
  MULTI_SELECT_RANGE = "MULTI_SELECT_RANGE",
  SINGLE_SELECT = "SINGLE_SELECT",
  TEXT = "TEXT",
}
/** Activity Page Type - infosite */
export enum ActivityPageType {
  ACTIVITY_INFO = "ACTIVITY_INFO",
}
/** Activity page Meta Tag types - NamedMetaTag, PropertyMetaTag and so on */
export enum ActivityPageMetaTagType {
  HTTP_EQUIV = "HTTP_EQUIV",
  NAME = "NAME",
  PROPERTY = "PROPERTY",
}
/** The text direction of the locale e.g. ltr or rtl */
export enum TextDirection {
  LTR = "LTR",
  RTL = "RTL",
}
/** Cabin class chosen in flight */
export enum FlightsCabinClass {
  BUSINESS = "BUSINESS",
  COACH = "COACH",
  FIRST = "FIRST",
  PREMIUM_ECONOMY = "PREMIUM_ECONOMY",
}
/** Possible advanced filter types */
export enum FlightsAdvancedFilterType {
  NONSTOP = "NONSTOP",
  REFUNDABLE = "REFUNDABLE",
}
/** Possible traveler details types */
export enum TravelerDetailsType {
  ADULT = "ADULT",
  CHILD = "CHILD",
  INFANT_IN_LAP = "INFANT_IN_LAP",
  INFANT_IN_SEAT = "INFANT_IN_SEAT",
}
/** Trip type chosen in flight search */
export enum FlightsTripType {
  MULTI_DESTINATION = "MULTI_DESTINATION",
  ONE_WAY = "ONE_WAY",
  ROUND_TRIP = "ROUND_TRIP",
}
/** Possible equipment requested by the customer */
export enum SpecialEquipment {
  ADDITIONAL_DRIVER = "ADDITIONAL_DRIVER",
  BICYCLE_RACK = "BICYCLE_RACK",
  BOOSTER_SEAT = "BOOSTER_SEAT",
  INFANT_SEAT = "INFANT_SEAT",
  LEFT_HAND_CONTROL = "LEFT_HAND_CONTROL",
  LUGGAGE_RACK = "LUGGAGE_RACK",
  NAV_SYSTEM = "NAV_SYSTEM",
  RIGHT_HAND_CONTROL = "RIGHT_HAND_CONTROL",
  ROAD_CONGESTION_PAYMENT_SCHEME = "ROAD_CONGESTION_PAYMENT_SCHEME",
  SATELLITE_RADIO = "SATELLITE_RADIO",
  SKI_RACK = "SKI_RACK",
  SNOW_CHAINS = "SNOW_CHAINS",
  SNOW_TIRES = "SNOW_TIRES",
  TODDLER_SEAT = "TODDLER_SEAT",
  TOLL_PAYMENT_TAG_PASS = "TOLL_PAYMENT_TAG_PASS",
  TRAILER_HITCH = "TRAILER_HITCH",
  WIFI_ACCESS = "WIFI_ACCESS",
  WINTER_PACKAGE = "WINTER_PACKAGE",
}
/** Indicate the inventory type of a given offer */
export enum InventoryType {
  AICTRAVELGROUP = "AICTRAVELGROUP",
  AMOMA = "AMOMA",
  ANA = "ANA",
  BESTBUYHOTEL = "BESTBUYHOTEL",
  BONOTEL = "BONOTEL",
  CNTRAVEL = "CNTRAVEL",
  CTRIP = "CTRIP",
  DESPEGAR = "DESPEGAR",
  DIDATRAVEL = "DIDATRAVEL",
  DIRECT_AGENCY = "DIRECT_AGENCY",
  EUROPLAYAS = "EUROPLAYAS",
  EXCITEHOLIDAYS = "EXCITEHOLIDAYS",
  EZZEGO_1 = "EZZEGO_1",
  GETAROOM = "GETAROOM",
  HOME_AWAY = "HOME_AWAY",
  HOTELDOBESTDAYTRAVEL = "HOTELDOBESTDAYTRAVEL",
  HOTEL_BEDS = "HOTEL_BEDS",
  HRS = "HRS",
  JAC_TRAVEL = "JAC_TRAVEL",
  JAL = "JAL",
  JALAN = "JALAN",
  JTB = "JTB",
  JUMBOTOURS = "JUMBOTOURS",
  MAGICROOMS = "MAGICROOMS",
  MERCHANT = "MERCHANT",
  MGBEDBANK = "MGBEDBANK",
  MIKI = "MIKI",
  MTS = "MTS",
  NTA = "NTA",
  NUITEE = "NUITEE",
  OPAQUE = "OPAQUE",
  OSTROVOK = "OSTROVOK",
  PEGASUS = "PEGASUS",
  RAKUTEN = "RAKUTEN",
  RESTEL = "RESTEL",
  ROOMER = "ROOMER",
  SMYROOMS = "SMYROOMS",
  SUNHOTELS = "SUNHOTELS",
  THOMASCOOK_EUR = "THOMASCOOK_EUR",
  THOMASCOOK_UK = "THOMASCOOK_UK",
  TOURICO = "TOURICO",
  TRAVELLANDA = "TRAVELLANDA",
  TRAVELREPUBLIC = "TRAVELREPUBLIC",
  VENERE = "VENERE",
  VRBO = "VRBO",
  WELCOME_BEDS = "WELCOME_BEDS",
  WOORI = "WOORI",
  WORLDHOTELLINK = "WORLDHOTELLINK",
  WORLDSPAN = "WORLDSPAN",
  WOTIF = "WOTIF",
  YOUTRAVEL = "YOUTRAVEL",
  ZUMATA = "ZUMATA",
}
/** Indicate the shopping path of a given offer */
export enum ShoppingPathType {
  ATTACH = "ATTACH",
  PACKAGE = "PACKAGE",
  STANDALONE = "STANDALONE",
}

export enum CrossSellProductType {
  ACTIVITY = "ACTIVITY",
  CAR = "CAR",
  FLIGHT = "FLIGHT",
  HOTEL = "HOTEL",
}
/** Options that alter behavior of mutation - for backward compatibility */
export enum PrepareCheckoutResponseOption {
  ALTERNATIVE_ACTION_ON_FAILURE = "ALTERNATIVE_ACTION_ON_FAILURE",
}

export enum CruiseFeature {
  MEMBER_DEALS = "MEMBER_DEALS",
}

export enum PropertyFilterAccessibility {
  ACCESSIBLE_BATHROOM = "ACCESSIBLE_BATHROOM",
  IN_ROOM_ACCESSIBLE = "IN_ROOM_ACCESSIBLE",
  ROLL_IN_SHOWER = "ROLL_IN_SHOWER",
}

export enum AgencyBusinessModel {
  EXPEDIA_COLLECT = "EXPEDIA_COLLECT",
  HOTEL_COLLECT = "HOTEL_COLLECT",
}

export enum PropertyFilterAmenity {
  AIR_CONDITIONING = "AIR_CONDITIONING",
  ALL_INCLUSIVE = "ALL_INCLUSIVE",
  BEACH = "BEACH",
  CASINO = "CASINO",
  FREE_AIRPORT_TRANSPORTATION = "FREE_AIRPORT_TRANSPORTATION",
  FREE_BREAKFAST = "FREE_BREAKFAST",
  FREE_PARKING = "FREE_PARKING",
  GOLF = "GOLF",
  HOT_SPRING = "HOT_SPRING",
  HOT_TUB = "HOT_TUB",
  KITCHEN_KITCHEN = "KITCHEN_KITCHEN",
  KITCHEN_KITCHENETTE = "KITCHEN_KITCHENETTE",
  OCEAN_VIEW = "OCEAN_VIEW",
  PETS = "PETS",
  POOL = "POOL",
  SPA_ON_SITE = "SPA_ON_SITE",
  WASHER_DRYER = "WASHER_DRYER",
  WATER_PARK = "WATER_PARK",
  WIFI = "WIFI",
}

export enum CleaningAndSafetyPractice {
  ENHANCED_CLEANING = "ENHANCED_CLEANING",
}

export enum CommissionTier {
  BASIC = "BASIC",
  BASIC_PLUS = "BASIC_PLUS",
  PREMIUM = "PREMIUM",
  PREMIUM_PLUS = "PREMIUM_PLUS",
}

export enum DealType {
  AARP = "AARP",
  POINTS_PROMOTION = "POINTS_PROMOTION",
}

export enum MealPlanFilterAmenity {
  ALL_INCLUSIVE = "ALL_INCLUSIVE",
  FREE_BREAKFAST = "FREE_BREAKFAST",
  FULL_BOARD = "FULL_BOARD",
  HALF_BOARD = "HALF_BOARD",
}

export enum PaymentType {
  COUPON_ELIGIBLE = "COUPON_ELIGIBLE",
  FREE_CANCELLATION = "FREE_CANCELLATION",
  PAY_LATER = "PAY_LATER",
  PAY_LATER_WITH_DEPOSIT = "PAY_LATER_WITH_DEPOSIT",
  PAY_WITHOUT_CREDITCARD = "PAY_WITHOUT_CREDITCARD",
}

export enum PropertyStyle {
  BOUTIQUE = "BOUTIQUE",
  HOMES = "HOMES",
  HOTELS = "HOTELS",
  LGBT = "LGBT",
  LUXURY = "LUXURY",
  OUTDOOR = "OUTDOOR",
  UNIQUE = "UNIQUE",
}

export enum StructureType {
  AGRITOURISM = "AGRITOURISM",
  ALL_INCLUSIVE = "ALL_INCLUSIVE",
  APARTMENT = "APARTMENT",
  APART_HOTEL = "APART_HOTEL",
  BED_AND_BREAKFAST = "BED_AND_BREAKFAST",
  CABIN = "CABIN",
  CAPSULE_HOTEL = "CAPSULE_HOTEL",
  CARAVAN_PARK = "CARAVAN_PARK",
  CASTLE = "CASTLE",
  CHALET = "CHALET",
  CONDO = "CONDO",
  CONDO_RESORT = "CONDO_RESORT",
  COTTAGE = "COTTAGE",
  COUNTRY_HOUSE = "COUNTRY_HOUSE",
  CRUISE = "CRUISE",
  ECO_HOTEL = "ECO_HOTEL",
  GUEST_HOUSE = "GUEST_HOUSE",
  HOLIDAY_PARK = "HOLIDAY_PARK",
  HOSTAL = "HOSTAL",
  HOSTEL = "HOSTEL",
  HOTEL = "HOTEL",
  HOTEL_RESORT = "HOTEL_RESORT",
  HOUSE_BOAT = "HOUSE_BOAT",
  INN = "INN",
  LODGE = "LODGE",
  LONGHOUSE = "LONGHOUSE",
  MOTEL = "MOTEL",
  OVERWATER = "OVERWATER",
  PALACE = "PALACE",
  PENSION = "PENSION",
  POUSADA_BRAZIL = "POUSADA_BRAZIL",
  POUSADA_PORTUGAL = "POUSADA_PORTUGAL",
  RANCH = "RANCH",
  RESIDENCE = "RESIDENCE",
  RIAD = "RIAD",
  RYOKAN = "RYOKAN",
  SAFARI = "SAFARI",
  SERVICED_APARTMENT = "SERVICED_APARTMENT",
  TOWNHOUSE = "TOWNHOUSE",
  TRADITIONAL_BUILDING = "TRADITIONAL_BUILDING",
  TREE_HOUSE = "TREE_HOUSE",
  UNKNOWN = "UNKNOWN",
  VACATION_HOME = "VACATION_HOME",
  VILLA = "VILLA",
  VIP = "VIP",
}

export enum TravelerType {
  BUSINESS = "BUSINESS",
  FAMILY = "FAMILY",
  ROMANTIC = "ROMANTIC",
}
/** Search options that are not filters. Previously these were a large set of boolean flags in ExpWeb called `searchOptions` */
export enum PropertySearchOptions {
  ADS_ONLY = "ADS_ONLY",
  SHOP_WITH_POINTS = "SHOP_WITH_POINTS",
}
/** Hotel sort types */
export enum PropertySort {
  AARP_MEMBER_DISCOUNT = "AARP_MEMBER_DISCOUNT",
  BEST_DEAL = "BEST_DEAL",
  DISTANCE = "DISTANCE",
  MEMBER_PRICING = "MEMBER_PRICING",
  PRICE_HIGH_TO_LOW = "PRICE_HIGH_TO_LOW",
  PRICE_LOW_TO_HIGH = "PRICE_LOW_TO_HIGH",
  PRICE_RELEVANT = "PRICE_RELEVANT",
  PROPERTY_CLASS = "PROPERTY_CLASS",
  PROPERTY_NAME = "PROPERTY_NAME",
  RECOMMENDED = "RECOMMENDED",
  REVIEW = "REVIEW",
  VACATION_RENTAL = "VACATION_RENTAL",
}
/** Options that are not filters. Refer @code { SearchOptions } */
export enum PropertyInfoOptions {
  SHOP_WITH_POINTS = "SHOP_WITH_POINTS",
}
/** Used to indicate what type of markup a field contains */
export enum MarkupTextType {
  HTML = "HTML",
}

export enum BadgeIcon {
  ACCESS_TIME = "ACCESS_TIME",
  ADD = "ADD",
  BUNDLED_SAVINGS_PLUS = "BUNDLED_SAVINGS_PLUS",
  EXP29639_ORB = "EXP29639_ORB",
  FAMILY_FRIENDLY = "FAMILY_FRIENDLY",
  INFO_OUTLINE = "INFO_OUTLINE",
  LOB_DEALS = "LOB_DEALS",
  LOCAL_OFFER = "LOCAL_OFFER",
  MOD = "MOD",
  SMARTPHONE = "SMARTPHONE",
}

export enum Theme {
  BRAND = "BRAND",
  BRANDED_DEAL = "BRANDED_DEAL",
  DEAL_ADD_ON = "DEAL_ADD_ON",
  DEAL_BUNDLED = "DEAL_BUNDLED",
  DEAL_GENERIC = "DEAL_GENERIC",
  DEAL_MEMBER = "DEAL_MEMBER",
  FAMILY_FRIENDLY = "FAMILY_FRIENDLY",
  INFO = "INFO",
  LINK = "LINK",
  LOYALTY = "LOYALTY",
  LOYALTY_HIGH_TIER = "LOYALTY_HIGH_TIER",
  LOYALTY_LOW_TIER = "LOYALTY_LOW_TIER",
  LOYALTY_MIDDLE_TIER = "LOYALTY_MIDDLE_TIER",
  NOTIFICATION = "NOTIFICATION",
  SAVED = "SAVED",
  SPONSORED = "SPONSORED",
  SUCCESS = "SUCCESS",
  SUCCESS_MEDIUM = "SUCCESS_MEDIUM",
  SUPPLIER_PROMO = "SUPPLIER_PROMO",
  URGENT = "URGENT",
  VIEWED = "VIEWED",
  VIP = "VIP",
  VIP_ACCESS = "VIP_ACCESS",
}
/** Theme information for a message. */
export enum LodgingMessageTheme {
  AGGRESSIVE = "AGGRESSIVE",
  HIGHLIGHT = "HIGHLIGHT",
  STRONG = "STRONG",
}
/** Describes what kind of action being described. Copy for example describes thecoupon code copy behavior. Authwindow shows the login/signup dialog. */
export enum ActionDetailsType {
  AUTHWINDOW = "AUTHWINDOW",
  COPY = "COPY",
  DATEPICKER = "DATEPICKER",
  EXTERNAL_LINK = "EXTERNAL_LINK",
  FREE_LX = "FREE_LX",
  OPEN = "OPEN",
  TERMS_AND_CONDITIONS = "TERMS_AND_CONDITIONS",
}
/** Unique identifier for a message if one needs to identify the reason for the message creation */
export enum MessageType {
  ADDON = "ADDON",
  COMPRESSION = "COMPRESSION",
  COUPON = "COUPON",
  DOUBLE_POINTS = "DOUBLE_POINTS",
  FREE_CANCELLATION = "FREE_CANCELLATION",
  FREE_LX = "FREE_LX",
  HOTRATE = "HOTRATE",
  LEGAL = "LEGAL",
  LOGIN = "LOGIN",
  LOYALTY = "LOYALTY",
  NO_CC = "NO_CC",
  OVERFILTERED = "OVERFILTERED",
  PARTNER_LINKOFF = "PARTNER_LINKOFF",
  VACATION_RENTALS = "VACATION_RENTALS",
}

export enum AmenityCategory {
  ACCESSIBLE_ROLL_IN_SHOWER = "ACCESSIBLE_ROLL_IN_SHOWER",
  AIR_CONDITIONING = "AIR_CONDITIONING",
  ALL_INCLUSIVE = "ALL_INCLUSIVE",
  ARCADE = "ARCADE",
  BABYSITTING = "BABYSITTING",
  BAR = "BAR",
  BARBECUE = "BARBECUE",
  BOWLING = "BOWLING",
  BREAKFAST_AVAILABLE = "BREAKFAST_AVAILABLE",
  BREAKFAST_INCLUDED = "BREAKFAST_INCLUDED",
  BREAKFAST_NOT_AVAILABLE = "BREAKFAST_NOT_AVAILABLE",
  BUSINESS_SERVICES = "BUSINESS_SERVICES",
  CHILDREN_CLUB = "CHILDREN_CLUB",
  DAILY_HOUSEKEEPING = "DAILY_HOUSEKEEPING",
  EXTRA_BED = "EXTRA_BED",
  FIRE_PLACE = "FIRE_PLACE",
  FITNESS_EQUIPMENT = "FITNESS_EQUIPMENT",
  FREE_AIRPORT_TRANSPORTATION = "FREE_AIRPORT_TRANSPORTATION",
  FREE_BREAKFAST = "FREE_BREAKFAST",
  FREE_CANCEL = "FREE_CANCEL",
  FREE_PARKING = "FREE_PARKING",
  FREE_WELCOME_DRINK = "FREE_WELCOME_DRINK",
  FREE_WIRED_INTERNET = "FREE_WIRED_INTERNET",
  FRONT_DESK_24_HOURS = "FRONT_DESK_24_HOURS",
  GROCERY = "GROCERY",
  HIGH_SPEED_INTERNET = "HIGH_SPEED_INTERNET",
  HOT_TUB = "HOT_TUB",
  INTERNET_NOT_AVAILABLE = "INTERNET_NOT_AVAILABLE",
  IN_ROOM_INTERNET = "IN_ROOM_INTERNET",
  KIDS_POOL = "KIDS_POOL",
  KITCHEN = "KITCHEN",
  LAUNDRY = "LAUNDRY",
  LIVING_AREA = "LIVING_AREA",
  MICROWAVE = "MICROWAVE",
  MINI_GOLF = "MINI_GOLF",
  NON_REFUNDABLE = "NON_REFUNDABLE",
  ON_PRIVATE_BEACH = "ON_PRIVATE_BEACH",
  ON_THE_BEACH = "ON_THE_BEACH",
  OUTDOOR_SPACE = "OUTDOOR_SPACE",
  PARKING = "PARKING",
  PARTIAL_REFUND = "PARTIAL_REFUND",
  PETS_ALLOWED = "PETS_ALLOWED",
  PLAYGROUND = "PLAYGROUND",
  POOL = "POOL",
  RESERVE_NOW_PAY_DEPOSIT = "RESERVE_NOW_PAY_DEPOSIT",
  RESERVE_NOW_PAY_LATER = "RESERVE_NOW_PAY_LATER",
  RESTAURANT_IN_HOTEL = "RESTAURANT_IN_HOTEL",
  ROOM_SERVICE = "ROOM_SERVICE",
  SMOKE_FREE = "SMOKE_FREE",
  SOUNDPROOF_ROOM = "SOUNDPROOF_ROOM",
  SPA_SERVICES_ON_SITE = "SPA_SERVICES_ON_SITE",
  SPECIAL_DEAL = "SPECIAL_DEAL",
  TENNIS_COURT = "TENNIS_COURT",
  TOYS = "TOYS",
  WASHER = "WASHER",
  WATERSLIDE = "WATERSLIDE",
  WIFI_SURCHARGE = "WIFI_SURCHARGE",
  WIRED_INTERNET_SURCHARGE = "WIRED_INTERNET_SURCHARGE",
}
/** Indicate what are the payment options for a given offer */
export enum PropertyPaymentType {
  PAY_LATER = "PAY_LATER",
  PAY_LATER_WITH_DEPOSIT = "PAY_LATER_WITH_DEPOSIT",
  PAY_NOW = "PAY_NOW",
}

export enum LodgingInputType {
  EMAIL = "EMAIL",
  HIDDEN = "HIDDEN",
  PASSWORD = "PASSWORD",
  TEL = "TEL",
  TEXT = "TEXT",
  URL = "URL",
}

export enum LodgingFormMethod {
  GET = "GET",
  POST = "POST",
}

export enum PropertyCancellationPolicyType {
  NON_REFUNDABLE = "NON_REFUNDABLE",
  REFUNDABLE_WITH_NO_PENALTY = "REFUNDABLE_WITH_NO_PENALTY",
  REFUNDABLE_WITH_PENALTY = "REFUNDABLE_WITH_PENALTY",
}

export enum RateDiscountType {
  MEMBER_DEAL = "MEMBER_DEAL",
  MOBILE_EXCLUSIVE = "MOBILE_EXCLUSIVE",
  REGULAR = "REGULAR",
  TONIGHT_ONLY = "TONIGHT_ONLY",
}

export enum FeeType {
  CARD_ON_FILE_DAMAGE_LIABILITY = "CARD_ON_FILE_DAMAGE_LIABILITY",
  DEFAULT = "DEFAULT",
  DEFAULT_SUPPLIER_COLLECTED = "DEFAULT_SUPPLIER_COLLECTED",
  GROUPED_MANDATORY_FEES = "GROUPED_MANDATORY_FEES",
  L26_TAX_BREAKOUT = "L26_TAX_BREAKOUT",
  NORMAL = "NORMAL",
  OTHER = "OTHER",
  PER_PERSON_PER_NIGHT = "PER_PERSON_PER_NIGHT",
  PROPERTY = "PROPERTY",
  REFUNDABLE_DAMAGE_DEPOSIT = "REFUNDABLE_DAMAGE_DEPOSIT",
  RESORT = "RESORT",
}

export enum PropertyPaymentModel {
  PAY_LATER = "PAY_LATER",
  PAY_LATER_WITH_DEPOSIT = "PAY_LATER_WITH_DEPOSIT",
  PAY_NOW = "PAY_NOW",
}

export enum StrikeOutType {
  ATTACH = "ATTACH",
  INVALID = "INVALID",
  LOYALTY = "LOYALTY",
  PACKAGE = "PACKAGE",
  PRICE_SURVEY = "PRICE_SURVEY",
  STANDALONE = "STANDALONE",
}

export enum PricingSchemeType {
  DAILY_RATE = "DAILY_RATE",
  TOTAL_RATE = "TOTAL_RATE",
}

export enum SourceType {
  ESR = "ESR",
  GDS = "GDS",
}

export enum PropertySectionRef {
  RECOMMENDED_OFFER = "RECOMMENDED_OFFER",
  ROOMS_AND_RATES = "ROOMS_AND_RATES",
}

export enum DamageLiability {
  COF = "COF",
  RDD = "RDD",
}
/** Filters review results by category type */
export enum PropertyReviewCategory {
  BUSINESS_TRAVELERS = "BUSINESS_TRAVELERS",
  COUPLES = "COUPLES",
  EVERYONE = "EVERYONE",
  FAMILIES = "FAMILIES",
  GETAWAY_WITH_FRIENDS = "GETAWAY_WITH_FRIENDS",
  GOLF = "GOLF",
  OTHER = "OTHER",
  OVERNIGHT_STAY = "OVERNIGHT_STAY",
  PERSONAL_EVENT = "PERSONAL_EVENT",
  SHOPPING = "SHOPPING",
  SPA = "SPA",
  STUDENTS = "STUDENTS",
}
/** [Optional] Review filter type */
export enum PropertyReviewType {
  CRITICAL = "CRITICAL",
  POSITIVE = "POSITIVE",
  RECENT = "RECENT",
}
/** [Optional] Hotel reviews sort types. Defaults to NEWEST_TO_OLDEST_BY_LANGUAGE */
export enum PropertyReviewSort {
  HIGHEST_TO_LOWEST_RATED = "HIGHEST_TO_LOWEST_RATED",
  LOWEST_TO_HIGHEST_RATED = "LOWEST_TO_HIGHEST_RATED",
  NEWEST_TO_OLDEST = "NEWEST_TO_OLDEST",
  NEWEST_TO_OLDEST_BY_LANGUAGE = "NEWEST_TO_OLDEST_BY_LANGUAGE",
  OLDEST_TO_NEWEST = "OLDEST_TO_NEWEST",
  OLDEST_TO_NEWEST_BY_LANGUAGE = "OLDEST_TO_NEWEST_BY_LANGUAGE",
}
/** Type that represents the amenity category icons for the property */
export enum PropertyAmenityCategoryType {
  ACCESSIBLE_ROLL_IN_SHOWER = "ACCESSIBLE_ROLL_IN_SHOWER",
  AIR_CONDITIONING = "AIR_CONDITIONING",
  ALL_INCLUSIVE = "ALL_INCLUSIVE",
  ARCADE = "ARCADE",
  BABYSITTING = "BABYSITTING",
  BAR = "BAR",
  BOWLING = "BOWLING",
  BREAKFAST_AVAILABLE = "BREAKFAST_AVAILABLE",
  BUSINESS_SERVICES = "BUSINESS_SERVICES",
  CHILDREN_CLUB = "CHILDREN_CLUB",
  DAILY_HOUSEKEEPING = "DAILY_HOUSEKEEPING",
  EXTRA_BED = "EXTRA_BED",
  FITNESS_EQUIPMENT = "FITNESS_EQUIPMENT",
  FREE_AIRPORT_TRANSPORTATION = "FREE_AIRPORT_TRANSPORTATION",
  FREE_BREAKFAST = "FREE_BREAKFAST",
  FREE_PARKING = "FREE_PARKING",
  FREE_WELCOME_DRINK = "FREE_WELCOME_DRINK",
  FRONT_DESK_24_HOURS = "FRONT_DESK_24_HOURS",
  GROCERY = "GROCERY",
  HIGH_SPEED_INTERNET = "HIGH_SPEED_INTERNET",
  HOT_TUB = "HOT_TUB",
  IN_ROOM_INTERNET = "IN_ROOM_INTERNET",
  KIDS_POOL = "KIDS_POOL",
  KITCHEN = "KITCHEN",
  LAUNDRY = "LAUNDRY",
  LIVING_AREA = "LIVING_AREA",
  MICROWAVE = "MICROWAVE",
  MINI_GOLF = "MINI_GOLF",
  PARKING = "PARKING",
  PETS_ALLOWED = "PETS_ALLOWED",
  PLAYGROUND = "PLAYGROUND",
  POOL = "POOL",
  RESTAURANT_IN_HOTEL = "RESTAURANT_IN_HOTEL",
  ROOM_SERVICE = "ROOM_SERVICE",
  SMOKE_FREE = "SMOKE_FREE",
  SOUNDPROOF_ROOM = "SOUNDPROOF_ROOM",
  SPA_SERVICES_ON_SITE = "SPA_SERVICES_ON_SITE",
  SPECIAL_DEAL = "SPECIAL_DEAL",
  TENNIS_COURT = "TENNIS_COURT",
  TOYS = "TOYS",
  WATERSLIDE = "WATERSLIDE",
}

export enum PropertyAmenityType {
  ACCESSIBILITY = "ACCESSIBILITY",
  BATHROOM = "BATHROOM",
  BEDROOM = "BEDROOM",
  BUSINESS_SERVICES = "BUSINESS_SERVICES",
  CONVENIENCES = "CONVENIENCES",
  ENTERTAINMENT = "ENTERTAINMENT",
  FAMILY_FRIENDLY = "FAMILY_FRIENDLY",
  FOOD_DRINK = "FOOD_DRINK",
  GUEST_SERVICES = "GUEST_SERVICES",
  INTERNET = "INTERNET",
  MORE = "MORE",
  OUTDOOR = "OUTDOOR",
  OUTDOOR_SPACE = "OUTDOOR_SPACE",
  PARKING = "PARKING",
  PROPERTY = "PROPERTY",
  ROOM = "ROOM",
  SPA = "SPA",
  THINGS_TO_DO = "THINGS_TO_DO",
}
/** Enumerated Gaia geographic region types */
export enum RegionType {
  ADDRESS = "ADDRESS",
  AIRPORT = "AIRPORT",
  CITY = "CITY",
  CONTINENT = "CONTINENT",
  COUNTRY = "COUNTRY",
  HIGH_LEVEL_REGION = "HIGH_LEVEL_REGION",
  METRO_STATION = "METRO_STATION",
  MULTI_CITY_VICINITY = "MULTI_CITY_VICINITY",
  NEIGHBORHOOD = "NEIGHBORHOOD",
  POINT_OF_INTEREST = "POINT_OF_INTEREST",
  PROVINCE_STATE = "PROVINCE_STATE",
  TRAIN_STATION = "TRAIN_STATION",
  UNKNOWN = "UNKNOWN",
}
/** The UDS icon used for the map marker */
export enum MapIconType {
  AIRPORT = "AIRPORT",
  CIRCLE = "CIRCLE",
  HOTEL = "HOTEL",
  LANDMARK = "LANDMARK",
  METRO = "METRO",
  RESTAURANT = "RESTAURANT",
  SOLD_OUT = "SOLD_OUT",
  TRAIN = "TRAIN",
}
/** The type of map marker */
export enum MarkerType {
  HOTEL = "HOTEL",
  POI = "POI",
}
/** ADs related property search options */
export enum Listings {
  ADS_ONLY = "ADS_ONLY",
}
/** Points related property search options */
export enum Points {
  SHOP_WITHOUT_POINTS = "SHOP_WITHOUT_POINTS",
  SHOP_WITH_POINTS = "SHOP_WITH_POINTS",
}
/** Enum of the units of measure and their abbreviations */
export enum DistanceUnit {
  KILOMETER = "KILOMETER",
  MILE = "MILE",
}

export enum OfferAttributeType {
  FREE_BREAKFAST = "FREE_BREAKFAST",
  FREE_CANCELLATION = "FREE_CANCELLATION",
  NO_CC_REQUIRED = "NO_CC_REQUIRED",
  PAYMENT_CHOICE = "PAYMENT_CHOICE",
  VIP = "VIP",
}

export enum PropertyPaymentFlags {
  ARTIFICIALLY_FENCED_RATE = "ARTIFICIALLY_FENCED_RATE",
  MIXED_RATE_PLAN = "MIXED_RATE_PLAN",
  NO_CREDIT_CARD = "NO_CREDIT_CARD",
}
/** Describes the type of product (line of business) that is being sold */
export enum LodgingCrossSellProductType {
  CAR = "CAR",
}
/** A rough measure of the percentage of properties that are sold out in thedestination region as calculated by the Urgency Service. */
export enum CompressionLevel {
  CAP = "CAP",
  HIGH = "HIGH",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  NA = "NA",
}
/** Supported capabilities of chatbot VAC. */
export enum ChatbotCapabilities {
  CLICKSTREAM = "CLICKSTREAM",
  GLASSBOX = "GLASSBOX",
}
/** Supported versions of chatbot. */
export enum ChatbotVersionId {
  V1 = "V1",
  V2 = "V2",
}
/** Indicates the coupon's active state */
export enum ActiveState {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  UNKNOWN = "UNKNOWN",
  USED = "USED",
}

export enum TripIntentPersonType {
  ADULT = "ADULT",
  CHILD = "CHILD",
}
/** The text style to apply to strings */
export enum CustomerNotificationPhrasePartStyle {
  EMPHASIS = "EMPHASIS",
  IMPORTANT = "IMPORTANT",
  STANDARD = "STANDARD",
}
/** Represents the target of the link */
export enum CustomerNotificationLinkTarget {
  NEW_TAB = "NEW_TAB",
  SAME_TAB = "SAME_TAB",
}
/** The display type of the Customer notification message */
export enum CustomerNotificationMessageDisplayType {
  FORM = "FORM",
  PAGE = "PAGE",
}
/** The level type of the Customer notification message */
export enum CustomerNotificationMessageLevel {
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
  WARNING = "WARNING",
}
/** The style to apply to phrase links */
export enum CustomerNotificationPhraseLinkStyle {
  FLOATING_ACTION_BUTTON = "FLOATING_ACTION_BUTTON",
  PRIMARY_BUTTON = "PRIMARY_BUTTON",
  SECONDARY_BUTTON = "SECONDARY_BUTTON",
  TERTIARY_BUTTON = "TERTIARY_BUTTON",
}
/** Represents the link type */
export enum CustomerNotificationLinkType {
  ANCHOR = "ANCHOR",
  APP_DOWNLOAD_LINK = "APP_DOWNLOAD_LINK",
  BUTTON = "BUTTON",
  FLOATING_ACTION_BUTTON = "FLOATING_ACTION_BUTTON",
  PRIMARY_BUTTON = "PRIMARY_BUTTON",
  SECONDARY_BUTTON = "SECONDARY_BUTTON",
  TERTIARY_BUTTON = "TERTIARY_BUTTON",
}

export enum CustomerNotificationType {
  APP_DOWNLOAD = "APP_DOWNLOAD",
  APP_HERO = "APP_HERO",
  CITI_COBRAND = "CITI_COBRAND",
  GDPR = "GDPR",
  MAD_MARQUEE = "MAD_MARQUEE",
  NONE = "NONE",
  TRAVEL_ADVISORY = "TRAVEL_ADVISORY",
}

export enum HistoryType {
  ACTIVITY_DETAIL = "ACTIVITY_DETAIL",
  ACTIVITY_SEARCH = "ACTIVITY_SEARCH",
  CAR_DETAIL = "CAR_DETAIL",
  CAR_SEARCH = "CAR_SEARCH",
  CRUISE_SEARCH = "CRUISE_SEARCH",
  FLIGHT_DETAIL = "FLIGHT_DETAIL",
  FLIGHT_SEARCH = "FLIGHT_SEARCH",
  PACKAGE_SEARCH = "PACKAGE_SEARCH",
  PROPERTY_DETAIL = "PROPERTY_DETAIL",
  PROPERTY_SEARCH = "PROPERTY_SEARCH",
}

export enum FunnelLocation {
  CHECKOUT = "CHECKOUT",
  CHECKOUT_ERROR = "CHECKOUT_ERROR",
  CONFIRMATION = "CONFIRMATION",
  DETAILS = "DETAILS",
  ENTRY = "ENTRY",
  FEATURES = "FEATURES",
  PAYMENT_ERROR = "PAYMENT_ERROR",
  POST_BOOKING = "POST_BOOKING",
  SEARCH_RESULTS = "SEARCH_RESULTS",
  SYSTEM = "SYSTEM",
  USER = "USER",
}

export enum ExpLineOfBusiness {
  ACTIVITIES = "ACTIVITIES",
  CAR = "CAR",
  CRUISES = "CRUISES",
  FLIGHT = "FLIGHT",
  GROUNDTRANSFERS = "GROUNDTRANSFERS",
  HOTEL = "HOTEL",
  PACKAGES = "PACKAGES",
  RAILS = "RAILS",
  UNCLASSIFIED = "UNCLASSIFIED",
}

export enum NotificationLocation {
  AFTER_HEADER = "AFTER_HEADER",
  FOOTER = "FOOTER",
  IN_PAGE = "IN_PAGE",
  IN_PAGE_AD = "IN_PAGE_AD",
  POPUP = "POPUP",
  PRE_HEADER = "PRE_HEADER",
}
/** Search history grouping day range. */
export enum SearchHistoryDayRange {
  SEVEN_DAYS = "SEVEN_DAYS",
  THREE_DAYS = "THREE_DAYS",
}
/** Search history grouping destination type. */
export enum SearchHistoryDestinationType {
  METRO_CITY = "METRO_CITY",
}
/** Gender of the customer */
export enum CustomerGender {
  FEMALE = "FEMALE",
  MALE = "MALE",
  UNKNOWN = "UNKNOWN",
}
/** Represent all the possible traveler types */
export enum FlightsTravelerType {
  ADULT = "ADULT",
  CHILD = "CHILD",
  INFANT_IN_LAP = "INFANT_IN_LAP",
  INFANT_IN_SEAT = "INFANT_IN_SEAT",
}
/** Represents the state the client wants to query */
export enum FlightsQueryState {
  LOADED = "LOADED",
  LOADING = "LOADING",
}
/** Describes the type of actionable button. Types reference UDS tokens for buttons. */
export enum FlightsActionDisplayType {
  PRIMARY = "PRIMARY",
  SECONDARY = "SECONDARY",
  TERTIARY = "TERTIARY",
}
/** Available action types an actionable element */
export enum FlightsActionType {
  APPLY_FARE = "APPLY_FARE",
  CHOOSE_FARE = "CHOOSE_FARE",
  DISMISS = "DISMISS",
  ENABLE_SUGGESTED_FILTER = "ENABLE_SUGGESTED_FILTER",
  FETCH_SEARCH_LISTINGS = "FETCH_SEARCH_LISTINGS",
  GO_TO_CHECKOUT = "GO_TO_CHECKOUT",
  GO_TO_DETAILS = "GO_TO_DETAILS",
  GO_TO_NEXT_JOURNEY = "GO_TO_NEXT_JOURNEY",
  GO_TO_PACKAGES = "GO_TO_PACKAGES",
  GO_TO_SEARCH = "GO_TO_SEARCH",
  GO_TO_STOREFRONT = "GO_TO_STOREFRONT",
  LOAD_CROSS_SELL_DIALOG = "LOAD_CROSS_SELL_DIALOG",
  LOAD_STANDARD_OFFER_FARE_RULE_MODULE = "LOAD_STANDARD_OFFER_FARE_RULE_MODULE",
  LOAD_TAX_BREAKDOWN_DIALOG = "LOAD_TAX_BREAKDOWN_DIALOG",
  OPEN_BOOK_DIRECTLY_WITH_AIRLINES_DIALOG = "OPEN_BOOK_DIRECTLY_WITH_AIRLINES_DIALOG",
  OPEN_PRICE_SUMMARY = "OPEN_PRICE_SUMMARY",
  REDIRECT_TO_AIRLINES_FOR_BOOKING = "REDIRECT_TO_AIRLINES_FOR_BOOKING",
  REFRESH = "REFRESH",
  SEARCH_FORM_ADD_JOURNEY = "SEARCH_FORM_ADD_JOURNEY",
  SEARCH_FORM_CLOSE_BUTTON = "SEARCH_FORM_CLOSE_BUTTON",
  SEARCH_FORM_REMOVE_JOURNEY = "SEARCH_FORM_REMOVE_JOURNEY",
  SHARE_FEEDBACK = "SHARE_FEEDBACK",
}
/** Represents an object to be used to differentiate the type of Placards(Ex :Placards to be shown immediately vs those which are shown during server error */
export enum FlightsPlacardDisplayType {
  IMMEDIATE = "IMMEDIATE",
  SORT_FILTERS_SERVER_ERROR = "SORT_FILTERS_SERVER_ERROR",
}
/** The text style to apply to strings */
export enum FlightsPhrasePartStyle {
  EMPHASIS = "EMPHASIS",
  IMPORTANT = "IMPORTANT",
  STANDARD = "STANDARD",
}
/** Metrics names */
export enum FlightsMetricName {
  LISTINGS_SUPPLY_RESPONSE_TIME = "LISTINGS_SUPPLY_RESPONSE_TIME",
}
/** Tags Associated with the response */
export enum ResponseTagType {
  LISTINGS_PAGINATED = "LISTINGS_PAGINATED",
  LISTINGS_PAGINATED_SLICED = "LISTINGS_PAGINATED_SLICED",
  LISTING_CACHE_SOURCE = "LISTING_CACHE_SOURCE",
  LISTING_DOWNLEVEL_SOURCE = "LISTING_DOWNLEVEL_SOURCE",
  RESPONSE_SUMMARY_CACHED_CONFIG = "RESPONSE_SUMMARY_CACHED_CONFIG",
  RESPONSE_SUMMARY_CACHED_ML = "RESPONSE_SUMMARY_CACHED_ML",
  RESPONSE_SUMMARY_HYBRID = "RESPONSE_SUMMARY_HYBRID",
  RESPONSE_SUMMARY_LIVE = "RESPONSE_SUMMARY_LIVE",
  SIDESHEET_ORIGINAL = "SIDESHEET_ORIGINAL",
  SIDESHEET_STRINGIFIED = "SIDESHEET_STRINGIFIED",
  UNRECOGNIZED = "UNRECOGNIZED",
}
/** Represents the type of animation the dialog will use when displayed */
export enum FlightsDialogAnimation {
  FADE = "FADE",
  NONE = "NONE",
}
/** Css class names for datepicker cell content. */
export enum FlightsFareCalendarPriceTheme {
  NEGATIVE = "NEGATIVE",
  POSITIVE = "POSITIVE",
  UNDEFINED = "UNDEFINED",
}
/** Represent the fares needs to be present in listing results */
export enum FlightsFaresSeparationType {
  BASE_AND_UPSELL = "BASE_AND_UPSELL",
  ONLY_BASE = "ONLY_BASE",
  ONLY_UPSELL = "ONLY_UPSELL",
}
/** Represents flights component */
export enum FlightsDisplayComponent {
  SMART_NFF_ALTERNATE_SUGGESTION = "SMART_NFF_ALTERNATE_SUGGESTION",
}
/** Enum representing the various time slots in a day */
export enum FlightsTimeOfDay {
  AFTERNOON = "AFTERNOON",
  EARLY_MORNING = "EARLY_MORNING",
  EVENING = "EVENING",
  MORNING = "MORNING",
}
/** Enum class to represent the type of flexible change policies */
export enum FilterPolicyType {
  NO_CHANGE_FEE = "NO_CHANGE_FEE",
}
/** Enum class to represent the operation associated with num of stops */
export enum FlightsStopFilterOperation {
  EQUAL = "EQUAL",
  GREATER_THAN_EQUAL = "GREATER_THAN_EQUAL",
  LESS_THAN_EQUAL = "LESS_THAN_EQUAL",
}
/** Enum which lists the sort orders */
export enum FlightsSortOrder {
  DECREASING = "DECREASING",
  INCREASING = "INCREASING",
}
/** Enum class which lists all the supported sorting criteria */
export enum FlightsSortType {
  ARRIVAL = "ARRIVAL",
  DEPARTURE = "DEPARTURE",
  DURATION = "DURATION",
  PRICE = "PRICE",
  RECOMMENDED = "RECOMMENDED",
}
/** Represents the theme values for a Badge */
export enum FlightsBadgeTheme {
  DEAL_BUNDLED = "DEAL_BUNDLED",
  DEAL_GENERIC = "DEAL_GENERIC",
  DEAL_MEMBER = "DEAL_MEMBER",
  FAMILY_FRIENDLY = "FAMILY_FRIENDLY",
  NOTIFICATION = "NOTIFICATION",
  SAVED = "SAVED",
  SPONSORED = "SPONSORED",
  SUPPLIER_PROMO = "SUPPLIER_PROMO",
  VIEWED = "VIEWED",
  VIP = "VIP",
}

export enum FlightsFlexibleGridType {
  FLEX_SEARCH = "FLEX_SEARCH",
  FLEX_SEARCH_GRID = "FLEX_SEARCH_GRID",
  FLEX_SEARCH_NOT_APPLICABLE = "FLEX_SEARCH_NOT_APPLICABLE",
}
/** Represents cross sell product types that will be displayed */
export enum FlightCrossSellProductType {
  CAR = "CAR",
  HOTEL = "HOTEL",
}
/** Represents all the common information in the journey review block on FIS */
export enum FreeCancellationApplicability {
  ALL_JOURNEYS = "ALL_JOURNEYS",
  CURRENT_JOUNRNEY = "CURRENT_JOUNRNEY",
  NOT_APPLICABLE = "NOT_APPLICABLE",
}

export enum FlightsFilterType {
  ARRIVAL_AIRPORT = "ARRIVAL_AIRPORT",
  ARRIVAL_TIME = "ARRIVAL_TIME",
  DEPARTURE_AIRPORT = "DEPARTURE_AIRPORT",
  DEPARTURE_TIME = "DEPARTURE_TIME",
  DURATION = "DURATION",
  FLEXIBLE_CHANGE_POLICIES = "FLEXIBLE_CHANGE_POLICIES",
  NUM_OF_STOPS = "NUM_OF_STOPS",
  PREFERRED_AIRLINE = "PREFERRED_AIRLINE",
}
/** Represents the display of progress bar when the results are loading */
export enum FlightsProgressBarDisplay {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
}

export enum FlightsSearchFormErrorType {
  CHILD_AGE_MISSING = "CHILD_AGE_MISSING",
  DATE_BEFORE_PREVIOUS_DATE = "DATE_BEFORE_PREVIOUS_DATE",
  DATE_NOT_IN_VALID_RANGE = "DATE_NOT_IN_VALID_RANGE",
  DATE_NOT_IN_VALID_RANGE_TO_DEFAULT_DATE = "DATE_NOT_IN_VALID_RANGE_TO_DEFAULT_DATE",
  INFANT_AGE_MISSING = "INFANT_AGE_MISSING",
  INVALID_DATE_FORMAT = "INVALID_DATE_FORMAT",
  INVALID_TRAVELER_COUNT = "INVALID_TRAVELER_COUNT",
  LESS_THAN_MINIMUM_ADULT = "LESS_THAN_MINIMUM_ADULT",
  LOCATION_EMPTY = "LOCATION_EMPTY",
  LOCATION_SAME = "LOCATION_SAME",
  MAX_STAY_DURATION_ERROR = "MAX_STAY_DURATION_ERROR",
  SAME_CITY = "SAME_CITY",
  SPECIAL_CHARACTER_NOT_ALLOWED = "SPECIAL_CHARACTER_NOT_ALLOWED",
  TOO_SHORT_AIRPORT_STRING = "TOO_SHORT_AIRPORT_STRING",
  UNATTENDED_INFANT_IN_LAP = "UNATTENDED_INFANT_IN_LAP",
  UNATTENDED_INFANT_IN_SEAT = "UNATTENDED_INFANT_IN_SEAT",
}

export enum PoiMapItemCategory {
  ACTIVITY = "ACTIVITY",
  RESTAURANT = "RESTAURANT",
}

export enum UserCoordinateType {
  AIRPORT = "AIRPORT",
  PROPERTY = "PROPERTY",
}

export enum PoiMapItemCardType {
  POI_MAP_ITEM_SUMMARY_CARD = "POI_MAP_ITEM_SUMMARY_CARD",
}

export enum PoiMapPinType {
  AIRPORT = "AIRPORT",
  POI = "POI",
  PROPERTY = "PROPERTY",
}
/** ID used to identify a month for queries that bucket data by month */
export enum MonthId {
  APRIL = "APRIL",
  AUGUST = "AUGUST",
  DECEMBER = "DECEMBER",
  FEBRUARY = "FEBRUARY",
  JANUARY = "JANUARY",
  JULY = "JULY",
  JUNE = "JUNE",
  MARCH = "MARCH",
  MAY = "MAY",
  NOVEMBER = "NOVEMBER",
  OCTOBER = "OCTOBER",
  SEPTEMBER = "SEPTEMBER",
}

export enum ProductType {
  ARTICLE = "ARTICLE",
  CAR_DETAILS = "CAR_DETAILS",
  DESTINATION = "DESTINATION",
  DESTINATION_EXPERIENCE = "DESTINATION_EXPERIENCE",
  EXPERIENCE = "EXPERIENCE",
  EXPERT_TIP = "EXPERT_TIP",
  FLIGHT_SEARCH = "FLIGHT_SEARCH",
  LX_DETAILS = "LX_DETAILS",
  NEIGHBORHOOD = "NEIGHBORHOOD",
  POI_GAIA = "POI_GAIA",
  PROPERTY_DETAILS = "PROPERTY_DETAILS",
}

export enum FooterButtonType {
  PRIMARY = "PRIMARY",
  SECONDARY = "SECONDARY",
  TERTIARY = "TERTIARY",
}

export enum FooterSeparatorType {
  HORIZONTAL_RULE = "HORIZONTAL_RULE",
}
/** Line of business that is querying the global navigation elements. */
export enum GlobalNavigationLineOfBusiness {
  ACTIVITY = "ACTIVITY",
  CAR = "CAR",
  CRUISE = "CRUISE",
  FLIGHT = "FLIGHT",
  HOTEL = "HOTEL",
  PACKAGE = "PACKAGE",
  UNKNOWN = "UNKNOWN",
}
/** Different viewport sizes to display the header. */
export enum HeaderViewSize {
  EXTRA_LARGE = "EXTRA_LARGE",
  LARGE = "LARGE",
  MEDIUM = "MEDIUM",
  SMALL = "SMALL",
}
/** Header section alignment of elements to either the start or end of the section container. */
export enum HeaderAlignment {
  END = "END",
  START = "START",
}
/** Determines the type of button to display.  Primary or tertiary. */
export enum HeaderButtonType {
  PRIMARY = "PRIMARY",
  TERTIARY = "TERTIARY",
}
/** Used to position the header menu dropdown as well as icons in links and buttons.  Options are LEFT or RIGHT. */
export enum HeaderItemPosition {
  LEFT = "LEFT",
  RIGHT = "RIGHT",
}
/** Inserts a separator in header menus. */
export enum HeaderSeparatorType {
  HORIZONTAL_RULE = "HORIZONTAL_RULE",
}
/** Type of text.  Heading or subheading. */
export enum HeaderTextType {
  HEADING = "HEADING",
  SUBHEADING = "SUBHEADING",
}

export enum PickerTriggerPlacementType {
  MENU_ITEM = "MENU_ITEM",
  NAV_LINK = "NAV_LINK",
}

export enum PickerTriggerDisplayType {
  GLOBAL_NAV_BUTTON = "GLOBAL_NAV_BUTTON",
  GLOBAL_NAV_LINK = "GLOBAL_NAV_LINK",
}

export enum MemberWalletBadgeTheme {
  LOYALTY_HIGH_TIER = "LOYALTY_HIGH_TIER",
  LOYALTY_LOW_TIER = "LOYALTY_LOW_TIER",
  LOYALTY_MIDDLE_TIER = "LOYALTY_MIDDLE_TIER",
}

export enum PropertyDetailsPropertyType {
  HOTEL = "HOTEL",
  VACATION_RENTAL = "VACATION_RENTAL",
}

export enum CampaignProductType {
  ACTIVITY = "ACTIVITY",
  FLIGHT = "FLIGHT",
  HOTEL = "HOTEL",
  PACKAGE = "PACKAGE",
}

export enum RecommendedType {
  BESPOKE = "BESPOKE",
  DESTINATIONS = "DESTINATIONS",
  OFFERS = "OFFERS",
}

export enum CampaignOfferBadgeType {
  DEFAULT = "DEFAULT",
  DISCOUNT = "DISCOUNT",
}

export enum ProductQuestionTopic {
  HOTEL = "HOTEL",
}

export enum QuestionSortType {
  NEWEST_TO_OLDEST = "NEWEST_TO_OLDEST",
  OLDEST_TO_NEWEST = "OLDEST_TO_NEWEST",
}

export enum KeyPhrasesClientType {
  DEFAULT = "DEFAULT",
  FILTER = "FILTER",
  SNIPPET = "SNIPPET",
}

export enum CheckoutServiceResult {
  FAILURE = "FAILURE",
  SUCCESS = "SUCCESS",
}

export enum PaymentTokenType {
  CREDIT_CARD = "CREDIT_CARD",
  STORED_CARD = "STORED_CARD",
}

export enum PaymentMethodType {
  CREDIT_CARD = "CREDIT_CARD",
  PAYPAL = "PAYPAL",
  POINTS = "POINTS",
}

export enum ButtonType {
  PRIMARY = "PRIMARY",
  SECONDARY = "SECONDARY",
}

export enum PayWithPointsUpdateAction {
  APPLY = "APPLY",
  REMOVE = "REMOVE",
}

export enum InsuranceMutationStatus {
  FAILED = "FAILED",
  SUCCESS = "SUCCESS",
}

export enum InsuranceMutationType {
  ADD_INSURANCE = "ADD_INSURANCE",
  REMOVE_INSURANCE = "REMOVE_INSURANCE",
}

export enum CartFlightSearchType {
  MULTI_CITY = "MULTI_CITY",
  ONE_WAY = "ONE_WAY",
  ROUND_TRIP = "ROUND_TRIP",
}

export enum CartTtl {
  FIVE_MINUTES = "FIVE_MINUTES",
  SEVEN_DAYS = "SEVEN_DAYS",
  TWELVE_HOURS = "TWELVE_HOURS",
}
/** Supported Features on prepareCheckout */
export enum CheckoutOptionType {
  FENCING_ATTRIBUTES = "FENCING_ATTRIBUTES",
  SHOP_WITH_POINTS = "SHOP_WITH_POINTS",
}

export enum CustomerNotificationMessageType {
  INVALID_INPUT = "INVALID_INPUT",
  SERVICE_ERROR = "SERVICE_ERROR",
  SUCCESS = "SUCCESS",
}

export enum Result {
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
}
/** Display theme for TripsContentUnorderedList */
export enum TripsContentUnorderedListTheme {
  BULLETS = "BULLETS",
  NO_BULLETS = "NO_BULLETS",
}

export enum TripsLinkTarget {
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
}
/** Valid actions on Sort and Filter Modal */
export enum ShoppingSortAndFilterActionType {
  CLEAR_DATA = "CLEAR_DATA",
  CLOSE_AND_APPLY = "CLOSE_AND_APPLY",
  CLOSE_AND_DO_NOT_APPLY = "CLOSE_AND_DO_NOT_APPLY",
  OPEN_MODAL = "OPEN_MODAL",
}

export enum Severity {
  ERROR = "ERROR",
  WARNING = "WARNING",
}

export enum FeedbackPlacement {
  FIELD = "FIELD",
  MODULE = "MODULE",
  PAGE = "PAGE",
}

export enum CheckoutModule {
  INSURANCE = "INSURANCE",
  NONE = "NONE",
  PAYMENTS = "PAYMENTS",
}

export enum BadgeTheme {
  DEAL_GENERIC = "DEAL_GENERIC",
}
/** Ids of inputs that can currently exist as input in special requests */
export enum CheckoutSpecialRequestInputIds {
  ACCESSIBILITY_INPUT = "ACCESSIBILITY_INPUT",
  BEDDING_INPUT = "BEDDING_INPUT",
  SMOKING_INPUT = "SMOKING_INPUT",
  SPECIAL_REQUEST_TEXT = "SPECIAL_REQUEST_TEXT",
}
/** Types of html element inputs for special requests elements */
export enum CheckoutSpecialRequestInputElementType {
  CHECKBOX = "CHECKBOX",
  SELECT = "SELECT",
  TEXTAREA = "TEXTAREA",
}
/** Types of html elements for special requests */
export enum CheckoutSpecialRequestElementType {
  EXPANDO_LINK = "EXPANDO_LINK",
  HEADING = "HEADING",
}

export enum PropertyCalendarPriceTrend {
  NEGATIVE = "NEGATIVE",
  POSITIVE = "POSITIVE",
}
/** Indicates the type of intent. */
export enum ChatBotIntentType {
  CANCEL = "CANCEL",
  CHANGE = "CHANGE",
  VIEW_BOOKING = "VIEW_BOOKING",
}
/** Indicates the type of product. */
export enum ChatBotProductType {
  FLIGHT = "FLIGHT",
}
/** Indicates the waiver redemption state. */
export enum ChatBotWaiverRedemptionState {
  CREDIT_REDEMPTION = "CREDIT_REDEMPTION",
}
/** The button type of the Customer notification submit button */
export enum CustomerNotificationFormButtonType {
  FLOATING_ACTION_BUTTON = "FLOATING_ACTION_BUTTON",
  PRIMARY_BUTTON = "PRIMARY_BUTTON",
  SECONDARY_BUTTON = "SECONDARY_BUTTON",
  TERTIARY_BUTTON = "TERTIARY_BUTTON",
}

export enum FlightCabinClassInfo {
  BUSINESS = "BUSINESS",
  COACH = "COACH",
  FIRST = "FIRST",
  PREMIUM_ECONOMY = "PREMIUM_ECONOMY",
}

export enum FlightsFlexibleSearchHeaderCellTheme {
  DEFAULT = "DEFAULT",
  SEARCHED_DATE_HEADER = "SEARCHED_DATE_HEADER",
}

export enum FlightsFlexibleSearchLegendCellTheme {
  DEFAULT = "DEFAULT",
}

export enum FlightsFlexibleSearchResultCellTheme {
  DEFAULT_PRICE = "DEFAULT_PRICE",
  HIGHEST_PRICE = "HIGHEST_PRICE",
  LOWEST_PRICE = "LOWEST_PRICE",
  NO_PRICE = "NO_PRICE",
  SEARCHED_DATE = "SEARCHED_DATE",
  SEARCHED_DATE_LOWEST_PRICE = "SEARCHED_DATE_LOWEST_PRICE",
  SEARCHED_DATE_NO_PRICE = "SEARCHED_DATE_NO_PRICE",
  SEARCHED_DATE_UNAVAILABLE_FLIGHTS = "SEARCHED_DATE_UNAVAILABLE_FLIGHTS",
  UNAVAILABLE_FLIGHTS = "UNAVAILABLE_FLIGHTS",
}

export enum RouteType {
  MULTI_DESTINATION = "MULTI_DESTINATION",
  ONE_WAY = "ONE_WAY",
  ROUND_TRIP = "ROUND_TRIP",
}

// ====================================================
// END: Typescript template
// ====================================================

// ====================================================
// Documents
// ====================================================

export namespace BlossomCustomerNotification {
  export type Variables = {
    context: ContextInput;
    notificationLocation: NotificationLocation;
    lineOfBusiness: ExpLineOfBusiness;
    funnelLocation: FunnelLocation;
  };

  export type Query = {
    __typename?: "Query";

    customer: Customer;
  };

  export type Customer = {
    __typename?: "Customer";

    notification: Notification;
  };

  export type Notification = {
    __typename?: "CustomerNotification";

    type: CustomerNotificationType;

    title?: Title | null;

    body?: Body[] | null;

    containerLink?: ContainerLink | null;

    logo?: Logo | null;

    links?: Links[] | null;

    dismiss?: Dismiss | null;

    revealActions?: RevealActions[] | null;

    backgroundId?: string | null;

    backgroundImage?: BackgroundImage | null;
  };

  export type Title = {
    __typename?: "CustomerNotificationPhrase";

    items: Items[];
  };

  export type Items = {
    __typename?: CustomerNotificationPhraseLinkNodeInlineFragment["__typename"];

    text: string;

    styles: CustomerNotificationPhrasePartStyle[];
  } & CustomerNotificationPhraseLinkNodeInlineFragment;

  export type CustomerNotificationPhraseLinkNodeInlineFragment = {
    __typename?: "CustomerNotificationPhraseLinkNode";

    url?: Url | null;

    target?: CustomerNotificationLinkTarget | null;

    actions?: Actions[] | null;
  };

  export type Actions = CustomerNotificationAnalyticsInlineFragment | CustomerNotificationCookieInlineFragment;

  export type CustomerNotificationAnalyticsInlineFragment = {
    __typename?: "CustomerNotificationAnalytics";

    description?: string | null;

    referrerId: string;
  };

  export type CustomerNotificationCookieInlineFragment = {
    __typename?: "CustomerNotificationCookie";

    name: string;

    value: string;

    expires: string;
  };

  export type Body = {
    __typename?: "CustomerNotificationPhrase";

    items: _Items[];
  };

  export type _Items = {
    __typename?: _CustomerNotificationPhraseLinkNodeInlineFragment["__typename"];

    text: string;

    styles: CustomerNotificationPhrasePartStyle[];
  } & _CustomerNotificationPhraseLinkNodeInlineFragment;

  export type _CustomerNotificationPhraseLinkNodeInlineFragment = {
    __typename?: "CustomerNotificationPhraseLinkNode";

    url?: Url | null;

    target?: CustomerNotificationLinkTarget | null;

    actions?: _Actions[] | null;

    id?: string | null;

    icon?: Icon | null;
  };

  export type _Actions = _CustomerNotificationAnalyticsInlineFragment | _CustomerNotificationCookieInlineFragment;

  export type _CustomerNotificationAnalyticsInlineFragment = {
    __typename?: "CustomerNotificationAnalytics";

    description?: string | null;

    referrerId: string;
  };

  export type _CustomerNotificationCookieInlineFragment = {
    __typename?: "CustomerNotificationCookie";

    name: string;

    value: string;

    expires: string;
  };

  export type Icon = {
    __typename?: "Icon";

    id: string;

    description: string;
  };

  export type ContainerLink = {
    __typename?: "CustomerNotificationContainerLink";

    url?: Url | null;

    target?: CustomerNotificationLinkTarget | null;

    actions?: __Actions[] | null;
  };

  export type __Actions = __CustomerNotificationAnalyticsInlineFragment | __CustomerNotificationCookieInlineFragment;

  export type __CustomerNotificationAnalyticsInlineFragment = {
    __typename?: "CustomerNotificationAnalytics";

    description?: string | null;

    referrerId: string;
  };

  export type __CustomerNotificationCookieInlineFragment = {
    __typename?: "CustomerNotificationCookie";

    name: string;

    value: string;

    expires: string;
  };

  export type Logo = {
    __typename?: "Image";

    description: string;

    url: Url;
  };

  export type Links = {
    __typename?: "CustomerNotificationPhraseLinkNode";

    id?: string | null;

    text: string;

    url?: Url | null;

    icon?: _Icon | null;

    actions?: ___Actions[] | null;
  };

  export type _Icon = {
    __typename?: "Icon";

    id: string;

    description: string;
  };

  export type ___Actions = ___CustomerNotificationAnalyticsInlineFragment | ___CustomerNotificationCookieInlineFragment;

  export type ___CustomerNotificationAnalyticsInlineFragment = {
    __typename?: "CustomerNotificationAnalytics";

    description?: string | null;

    referrerId: string;
  };

  export type ___CustomerNotificationCookieInlineFragment = {
    __typename?: "CustomerNotificationCookie";

    name: string;

    value: string;

    expires: string;
  };

  export type Dismiss = {
    __typename?: "CustomerNotificationDismiss";

    icon: __Icon;

    actions?: ____Actions[] | null;
  };

  export type __Icon = {
    __typename?: "Icon";

    id: string;

    description: string;
  };

  export type ____Actions =
    | ____CustomerNotificationAnalyticsInlineFragment
    | ____CustomerNotificationCookieInlineFragment;

  export type ____CustomerNotificationAnalyticsInlineFragment = {
    __typename?: "CustomerNotificationAnalytics";

    description?: string | null;

    referrerId: string;
  };

  export type ____CustomerNotificationCookieInlineFragment = {
    __typename?: "CustomerNotificationCookie";

    name: string;

    value: string;

    expires: string;
  };

  export type RevealActions =
    | _____CustomerNotificationAnalyticsInlineFragment
    | _____CustomerNotificationCookieInlineFragment;

  export type _____CustomerNotificationAnalyticsInlineFragment = {
    __typename?: "CustomerNotificationAnalytics";

    description?: string | null;

    referrerId: string;
  };

  export type _____CustomerNotificationCookieInlineFragment = {
    __typename?: "CustomerNotificationCookie";

    name: string;

    value: string;

    expires: string;
  };

  export type BackgroundImage = {
    __typename?: "Image";

    url: Url;
  };
}

export namespace CampaignByIdQuery {
  export type Variables = {
    productType?: CampaignProductType[] | null;
    context: ContextInput;
    userLocation?: UserLocationInput | null;
    referrer?: string | null;
    enableTripAttach?: boolean | null;
    displayPropertyCount?: boolean | null;
    campaignId: string;
    pageSize?: number | null;
    pageNumber: number;
    enableLivePricing?: boolean | null;
    returnPath?: string | null;
  };

  export type Query = {
    __typename?: "Query";

    campaignRecommendations?: CampaignRecommendations | null;
  };

  export type CampaignRecommendations = {
    __typename?: "RecommendedCampaigns";

    campaigns: Campaigns[];

    responseId: Uuid;

    paginationInfo: PaginationInfo;
  };

  export type Campaigns = {
    __typename?: "CampaignDetail";

    id: string;

    headline: string;

    fromOriginHeaderText?: string | null;

    termsAndConditions: string;

    campaignContentPaginationInfo?: CampaignContentPaginationInfo | null;

    description: Description;

    productTypes: string[];

    recommendedType: RecommendedType;

    offers?: Offers[] | null;
  };

  export type CampaignContentPaginationInfo = {
    __typename?: "CampaignContentPaginationInfo";

    hasMoreContentPages: boolean;
  };

  export type Description = {
    __typename?: "CampaignDescriptions";

    short?: string | null;

    long?: string | null;
  };

  export type Offers = {
    __typename?:
      | DestinationOfferItemInlineFragment["__typename"]
      | HotelOfferItemInlineFragment["__typename"]
      | FlightOfferItemInlineFragment["__typename"]
      | PackageOfferItemInlineFragment["__typename"];

    name: string;

    image: Image;

    description?: string | null;

    secondaryContent?: string | null;
  } & (
    | DestinationOfferItemInlineFragment
    | HotelOfferItemInlineFragment
    | FlightOfferItemInlineFragment
    | PackageOfferItemInlineFragment
  );

  export type Image = {
    __typename?: "Image";

    description: string;

    url: Url;
  };

  export type DestinationOfferItemInlineFragment = {
    __typename?: "DestinationOfferItem";

    affinities?: string[] | null;

    propertyCount?: string | null;

    lodgingOffer?: LodgingOffer | null;

    flightOffer?: FlightOffer | null;

    packageOffer?: PackageOffer | null;

    dates?: string | null;
  };

  export type LodgingOffer = {
    __typename?: "OfferData";

    price: Price;

    actionLink: ActionLink;
  };

  export type Price = {
    __typename?: "OfferPrice";

    value: string;

    qualifierText: string;

    disclaimerText: string;
  };

  export type ActionLink = {
    __typename?: "OfferActionLink";

    href: string;

    text: string;
  };

  export type FlightOffer = {
    __typename?: "OfferData";

    price: _Price;

    actionLink: _ActionLink;
  };

  export type _Price = {
    __typename?: "OfferPrice";

    value: string;

    qualifierText: string;

    disclaimerText: string;

    prefixText?: string | null;
  };

  export type _ActionLink = {
    __typename?: "OfferActionLink";

    href: string;

    text: string;
  };

  export type PackageOffer = {
    __typename?: "OfferData";

    price: __Price;

    strikeThroughPrice?: StrikeThroughPrice | null;

    actionLink: __ActionLink;
  };

  export type __Price = {
    __typename?: "OfferPrice";

    value: string;

    qualifierText: string;

    disclaimerText: string;

    prefixText?: string | null;

    checkPriceText?: string | null;
  };

  export type StrikeThroughPrice = {
    __typename?: "OfferPrice";

    value: string;
  };

  export type __ActionLink = {
    __typename?: "OfferActionLink";

    href: string;

    text: string;
  };

  export type HotelOfferItemInlineFragment = {
    __typename?: "HotelOfferItem";

    location?: string | null;

    starRating?: number | null;

    guestReviewRating?: string | null;

    guestReviewRatingQualifierText?: string | null;

    guestReviewCount?: string | null;

    vipMessage?: string | null;

    freeCancellationMessage?: string | null;

    badge?: Badge | null;

    discountBadge?: DiscountBadge | null;

    mod?: Mod | null;

    lodgingOffer?: _LodgingOffer | null;

    dates?: string | null;
  };

  export type Badge = {
    __typename?: "CampaignOfferBadge";

    text?: string | null;

    type: CampaignOfferBadgeType;
  };

  export type DiscountBadge = {
    __typename?: "CampaignOfferBadge";

    text?: string | null;

    type: CampaignOfferBadgeType;
  };

  export type Mod = {
    __typename?: "MODItem";

    modTagText?: string | null;

    modAvailabilityText?: string | null;

    modSignInText?: string | null;

    signInUrl?: SignInUrl | null;
  };

  export type SignInUrl = {
    __typename?: "HttpURI";

    value: string;

    relativePath: string;
  };

  export type _LodgingOffer = {
    __typename?: "OfferData";

    price: ___Price;

    strikeThroughPrice?: _StrikeThroughPrice | null;

    actionLink: ___ActionLink;
  };

  export type ___Price = {
    __typename?: "OfferPrice";

    value: string;

    qualifierText: string;

    disclaimerText: string;

    allyText?: string | null;
  };

  export type _StrikeThroughPrice = {
    __typename?: "OfferPrice";

    value: string;
  };

  export type ___ActionLink = {
    __typename?: "OfferActionLink";

    href: string;

    text: string;
  };

  export type FlightOfferItemInlineFragment = {
    __typename?: "FlightOfferItem";

    airlineName?: string | null;

    airlineImage?: AirlineImage | null;

    originCity?: string | null;

    originAirportCode?: string | null;

    destinationCity?: string | null;

    destinationAirportCode?: string | null;

    tripType?: string | null;

    flightClass?: string | null;

    flightOffer?: _FlightOffer | null;

    dates?: string | null;
  };

  export type AirlineImage = {
    __typename?: "Image";

    description: string;

    url: Url;
  };

  export type _FlightOffer = {
    __typename?: "OfferData";

    price: ____Price;

    actionLink: ____ActionLink;
  };

  export type ____Price = {
    __typename?: "OfferPrice";

    value: string;

    qualifierText: string;

    prefixText?: string | null;
  };

  export type ____ActionLink = {
    __typename?: "OfferActionLink";

    href: string;

    text: string;
  };

  export type PackageOfferItemInlineFragment = {
    __typename?: "PackageOfferItem";

    flightOfferItem?: FlightOfferItem | null;

    hotelOfferItem?: HotelOfferItem | null;

    packageOffer?: _PackageOffer | null;

    dates?: string | null;
  };

  export type FlightOfferItem = {
    __typename?: "FlightOfferItem";

    airlineName?: string | null;

    airlineImage?: _AirlineImage | null;

    originCity?: string | null;

    originAirportCode?: string | null;

    destinationCity?: string | null;

    destinationAirportCode?: string | null;
  };

  export type _AirlineImage = {
    __typename?: "Image";

    description: string;

    url: Url;
  };

  export type HotelOfferItem = {
    __typename?: "HotelOfferItem";

    name: string;

    location?: string | null;

    vipMessage?: string | null;
  };

  export type _PackageOffer = {
    __typename?: "OfferData";

    price: _____Price;

    actionLink: _____ActionLink;
  };

  export type _____Price = {
    __typename?: "OfferPrice";

    value: string;

    qualifierText: string;

    prefixText?: string | null;

    checkPriceText?: string | null;
  };

  export type _____ActionLink = {
    __typename?: "OfferActionLink";

    href: string;

    text: string;
  };

  export type PaginationInfo = {
    __typename?: "CampaignPagination";

    referrer: string;
  };
}

export namespace CampaignRecommendationsWithOffersQuery {
  export type Variables = {
    numCampaigns: number;
    pageNumberOfCampaigns: number;
    maxNumberOfCampaigns?: number | null;
    productType?: CampaignProductType[] | null;
    recommendationType?: (RecommendedType | null)[] | null;
    context: ContextInput;
    userLocation?: UserLocationInput | null;
    referrer?: string | null;
    userTripState?: string | null;
    enableLivePricing?: boolean | null;
    returnPath?: string | null;
  };

  export type Query = {
    __typename?: "Query";

    campaignRecommendations?: CampaignRecommendations | null;
  };

  export type CampaignRecommendations = {
    __typename?: "RecommendedCampaigns";

    campaigns: Campaigns[];

    responseId: Uuid;

    paginationInfo: PaginationInfo;
  };

  export type Campaigns = {
    __typename?: "CampaignDetail";

    id: string;

    headline: string;

    fromOriginHeaderText?: string | null;

    termsAndConditions: string;

    description: Description;

    productTypes: string[];

    recommendedType: RecommendedType;

    offers?: Offers[] | null;
  };

  export type Description = {
    __typename?: "CampaignDescriptions";

    short?: string | null;

    long?: string | null;
  };

  export type Offers = {
    __typename?:
      | DestinationOfferItemInlineFragment["__typename"]
      | HotelOfferItemInlineFragment["__typename"]
      | FlightOfferItemInlineFragment["__typename"]
      | PackageOfferItemInlineFragment["__typename"];

    name: string;

    image: Image;

    description?: string | null;

    secondaryContent?: string | null;
  } & (
    | DestinationOfferItemInlineFragment
    | HotelOfferItemInlineFragment
    | FlightOfferItemInlineFragment
    | PackageOfferItemInlineFragment
  );

  export type Image = {
    __typename?: "Image";

    description: string;

    url: Url;
  };

  export type DestinationOfferItemInlineFragment = {
    __typename?: "DestinationOfferItem";

    affinities?: string[] | null;

    lodgingOffer?: LodgingOffer | null;

    flightOffer?: FlightOffer | null;

    packageOffer?: PackageOffer | null;

    dates?: string | null;
  };

  export type LodgingOffer = {
    __typename?: "OfferData";

    price: Price;

    actionLink: ActionLink;
  };

  export type Price = {
    __typename?: "OfferPrice";

    value: string;

    qualifierText: string;

    disclaimerText: string;

    prefixText?: string | null;

    checkPriceText?: string | null;
  };

  export type ActionLink = {
    __typename?: "OfferActionLink";

    href: string;

    text: string;
  };

  export type FlightOffer = {
    __typename?: "OfferData";

    price: _Price;

    actionLink: _ActionLink;
  };

  export type _Price = {
    __typename?: "OfferPrice";

    value: string;

    qualifierText: string;

    disclaimerText: string;

    prefixText?: string | null;

    checkPriceText?: string | null;
  };

  export type _ActionLink = {
    __typename?: "OfferActionLink";

    href: string;

    text: string;
  };

  export type PackageOffer = {
    __typename?: "OfferData";

    price: __Price;

    strikeThroughPrice?: StrikeThroughPrice | null;

    actionLink: __ActionLink;
  };

  export type __Price = {
    __typename?: "OfferPrice";

    value: string;

    qualifierText: string;

    disclaimerText: string;

    prefixText?: string | null;

    checkPriceText?: string | null;
  };

  export type StrikeThroughPrice = {
    __typename?: "OfferPrice";

    value: string;
  };

  export type __ActionLink = {
    __typename?: "OfferActionLink";

    href: string;

    text: string;
  };

  export type HotelOfferItemInlineFragment = {
    __typename?: "HotelOfferItem";

    location?: string | null;

    starRating?: number | null;

    guestReviewRating?: string | null;

    guestReviewRatingQualifierText?: string | null;

    guestReviewCount?: string | null;

    vipMessage?: string | null;

    freeCancellationMessage?: string | null;

    badge?: Badge | null;

    discountBadge?: DiscountBadge | null;

    mod?: Mod | null;

    lodgingOffer?: _LodgingOffer | null;

    dates?: string | null;
  };

  export type Badge = {
    __typename?: "CampaignOfferBadge";

    text?: string | null;

    type: CampaignOfferBadgeType;
  };

  export type DiscountBadge = {
    __typename?: "CampaignOfferBadge";

    text?: string | null;

    type: CampaignOfferBadgeType;
  };

  export type Mod = {
    __typename?: "MODItem";

    modTagText?: string | null;

    modAvailabilityText?: string | null;

    modSignInText?: string | null;

    signInUrl?: SignInUrl | null;
  };

  export type SignInUrl = {
    __typename?: "HttpURI";

    value: string;

    relativePath: string;
  };

  export type _LodgingOffer = {
    __typename?: "OfferData";

    price: ___Price;

    strikeThroughPrice?: _StrikeThroughPrice | null;

    actionLink: ___ActionLink;
  };

  export type ___Price = {
    __typename?: "OfferPrice";

    value: string;

    qualifierText: string;

    disclaimerText: string;

    allyText?: string | null;
  };

  export type _StrikeThroughPrice = {
    __typename?: "OfferPrice";

    value: string;
  };

  export type ___ActionLink = {
    __typename?: "OfferActionLink";

    href: string;

    text: string;
  };

  export type FlightOfferItemInlineFragment = {
    __typename?: "FlightOfferItem";

    airlineName?: string | null;

    airlineImage?: AirlineImage | null;

    originCity?: string | null;

    originAirportCode?: string | null;

    destinationCity?: string | null;

    destinationAirportCode?: string | null;

    tripType?: string | null;

    flightClass?: string | null;

    flightOffer?: _FlightOffer | null;

    dates?: string | null;
  };

  export type AirlineImage = {
    __typename?: "Image";

    description: string;

    url: Url;
  };

  export type _FlightOffer = {
    __typename?: "OfferData";

    price: ____Price;

    actionLink: ____ActionLink;
  };

  export type ____Price = {
    __typename?: "OfferPrice";

    value: string;

    qualifierText: string;

    prefixText?: string | null;
  };

  export type ____ActionLink = {
    __typename?: "OfferActionLink";

    href: string;

    text: string;
  };

  export type PackageOfferItemInlineFragment = {
    __typename?: "PackageOfferItem";

    flightOfferItem?: FlightOfferItem | null;

    hotelOfferItem?: HotelOfferItem | null;

    packageOffer?: _PackageOffer | null;

    dates?: string | null;
  };

  export type FlightOfferItem = {
    __typename?: "FlightOfferItem";

    airlineName?: string | null;

    airlineImage?: _AirlineImage | null;

    originCity?: string | null;

    originAirportCode?: string | null;

    destinationCity?: string | null;

    destinationAirportCode?: string | null;
  };

  export type _AirlineImage = {
    __typename?: "Image";

    description: string;

    url: Url;
  };

  export type HotelOfferItem = {
    __typename?: "HotelOfferItem";

    name: string;

    location?: string | null;

    vipMessage?: string | null;
  };

  export type _PackageOffer = {
    __typename?: "OfferData";

    price: _____Price;

    actionLink: _____ActionLink;
  };

  export type _____Price = {
    __typename?: "OfferPrice";

    value: string;

    qualifierText: string;

    prefixText?: string | null;

    checkPriceText?: string | null;
  };

  export type _____ActionLink = {
    __typename?: "OfferActionLink";

    href: string;

    text: string;
  };

  export type PaginationInfo = {
    __typename?: "CampaignPagination";

    referrer: string;

    hasNextPage: boolean;
  };
}

export namespace CustomerPropertySearchByIdQuery {
  export type Variables = {
    context: ContextInput;
    dateRange?: PropertyDateRangeInput | null;
    hotelIds?: string[] | null;
  };

  export type Query = {
    __typename?: "Query";

    propertySearch: PropertySearch;
  };

  export type PropertySearch = {
    __typename?: "PropertySearchResults";

    properties: Properties[];

    searchCriteria: SearchCriteria;
  };

  export type Properties = {
    __typename?: "Property";

    name: string;

    id: string;

    infositeURL: string;

    price?: Price | null;

    image?: Image | null;
  };

  export type Price = {
    __typename?: "PropertyPrice";

    options?: Options[] | null;
  };

  export type Options = {
    __typename?: "PropertyPriceOption";

    displayPrice?: DisplayPrice | null;
  };

  export type DisplayPrice = {
    __typename?: "Money";

    formatted: string;

    amount: number;

    currencyInfo?: CurrencyInfo | null;
  };

  export type CurrencyInfo = {
    __typename?: "Currency";

    symbol: string;

    code: string;

    name: string;
  };

  export type Image = {
    __typename?: "Image";

    url: Url;
  };

  export type SearchCriteria = {
    __typename?: "SearchCriteria";

    dateRange: DateRange;
  };

  export type DateRange = {
    __typename?: "PropertyDateRange";

    checkInDate: CheckInDate;

    checkOutDate: CheckOutDate;
  };

  export type CheckInDate = {
    __typename?: "Date";

    isoFormat: string;

    day: number;

    month: number;

    year: number;
  };

  export type CheckOutDate = {
    __typename?: "Date";

    isoFormat: string;

    day: number;

    month: number;

    year: number;
  };
}

export namespace CustomerSearchHistoryAllQuery {
  export type Variables = {
    context: ContextInput;
    lobs?: HistoryType[] | null;
    numberOfResults?: number | null;
  };

  export type Query = {
    __typename?: "Query";

    customer: Customer;
  };

  export type Customer = {
    __typename?: "Customer";

    searchHistory?: SearchHistory[] | null;
  };

  export type SearchHistory = {
    __typename?: "History";

    type?: HistoryType | null;

    items?: (Items | null)[] | null;
  };

  export type Items = {
    __typename?: "HistoryItem";

    id?: string | null;

    localizedDateRange?: string | null;

    localizedAsOfDateTime?: string | null;

    lastViewedDate: LastViewedDate;

    startDate: StartDate;

    endDate: EndDate;

    originalSearchPrice?: OriginalSearchPrice | null;

    productInfo?: ProductInfo | null;
  };

  export type LastViewedDate = {
    __typename?: "ZonedDateTime";

    day: number;

    hour: number;

    minute: number;

    second: number;

    month: number;

    year: number;
  };

  export type StartDate = {
    __typename?: "ZonedDateTime";

    raw: string;

    year: number;

    month: number;

    day: number;
  };

  export type EndDate = {
    __typename?: "ZonedDateTime";

    raw: string;

    year: number;

    month: number;

    day: number;
  };

  export type OriginalSearchPrice = {
    __typename?: "Money";

    currencyInfo?: CurrencyInfo | null;

    amount: number;

    formatted: string;
  };

  export type CurrencyInfo = {
    __typename?: "Currency";

    code: string;

    name: string;

    symbol: string;
  };

  export type ProductInfo =
    | HistoryActivitySearchInlineFragment
    | HistoryActivityDetailInlineFragment
    | HistoryFlightSearchInlineFragment
    | HistoryFlightDetailInlineFragment
    | HistoryPackageSearchInlineFragment
    | HistoryPropertySearchInlineFragment
    | HistoryPropertyDetailInlineFragment;

  export type HistoryActivitySearchInlineFragment = {
    __typename?: "HistoryActivitySearch";

    regionDetail?: RegionDetail | null;

    searchUrl?: string | null;
  };

  export type RegionDetail = {
    __typename?: "GeographicFeature";

    name: string;
  };

  export type HistoryActivityDetailInlineFragment = {
    __typename?: "HistoryActivityDetail";

    name?: string | null;

    duration?: string | null;

    leadTicketType?: string | null;

    imageUrl?: ImageUrl | null;

    searchUrl?: string | null;
  };

  export type ImageUrl = {
    __typename?: "Image";

    description: string;

    url: Url;
  };

  export type HistoryFlightSearchInlineFragment = {
    __typename?: "HistoryFlightSearch";

    localizedFlightName?: string | null;

    searchUrl?: string | null;

    routeType?: string | null;

    flightPassengers?: FlightPassengers | null;
  };

  export type FlightPassengers = {
    __typename?: "FlightPassengers";

    adults?: number | null;

    agesOfChildren?: number[] | null;
  };

  export type HistoryFlightDetailInlineFragment = {
    __typename?: "HistoryFlightDetail";

    localizedFlightName?: string | null;

    searchUrl?: string | null;

    routeType?: string | null;

    flightPassengers?: _FlightPassengers | null;
  };

  export type _FlightPassengers = {
    __typename?: "FlightPassengers";

    adults?: number | null;

    agesOfChildren?: number[] | null;
  };

  export type HistoryPackageSearchInlineFragment = {
    __typename?: "HistoryPackageSearch";

    localizedPackageName?: string | null;

    localizedRegionName?: string | null;

    localizedPackagesTemplate?: string | null;

    searchUrl?: string | null;
  };

  export type HistoryPropertySearchInlineFragment = {
    __typename?: "HistoryPropertySearch";

    regionDetail?: _RegionDetail | null;

    localizedRoomsTemplate?: string | null;

    searchUrl?: string | null;
  };

  export type _RegionDetail = {
    __typename?: "GeographicFeature";

    name: string;
  };

  export type HistoryPropertyDetailInlineFragment = {
    __typename?: "HistoryPropertyDetail";

    regionId?: string | null;

    summary?: Summary | null;

    regionDetail?: __RegionDetail | null;

    reviewInfo?: ReviewInfo | null;

    formattedRating: string;

    formattedReviewCount: string;

    propertyId?: string | null;

    gallery?: Gallery | null;

    searchUrl?: string | null;
  };

  export type Summary = {
    __typename?: "PropertySummary";

    id: string;

    name: string;
  };

  export type __RegionDetail = {
    __typename?: "GeographicFeature";

    name: string;
  };

  export type ReviewInfo = {
    __typename?: "PropertyReviews";

    summary: _Summary;
  };

  export type _Summary = {
    __typename?: "PropertyReviewSummary";

    averageOverallRating: AverageOverallRating;

    totalCount: TotalCount;
  };

  export type AverageOverallRating = {
    __typename?: "FormattedNumber";

    formatted: string;
  };

  export type TotalCount = {
    __typename?: "FormattedNumber";

    formatted: string;
  };

  export type Gallery = {
    __typename?: "PropertyGallery";

    featured?: Featured | null;
  };

  export type Featured = {
    __typename?: "Image";

    description: string;

    url: Url;
  };
}

export namespace CustomerSearchHistoryQuery {
  export type Variables = {
    context: ContextInput;
    lobs?: HistoryType[] | null;
    numberOfResults?: number | null;
  };

  export type Query = {
    __typename?: "Query";

    customer: Customer;
  };

  export type Customer = {
    __typename?: "Customer";

    searchHistory?: SearchHistory[] | null;
  };

  export type SearchHistory = {
    __typename?: "History";

    type?: HistoryType | null;

    items?: (Items | null)[] | null;
  };

  export type Items = {
    __typename?: "HistoryItem";

    startDate: StartDate;

    endDate: EndDate;

    originalSearchPrice?: OriginalSearchPrice | null;

    productInfo?: ProductInfo | null;
  };

  export type StartDate = {
    __typename?: "ZonedDateTime";

    raw: string;

    year: number;

    month: number;

    day: number;
  };

  export type EndDate = {
    __typename?: "ZonedDateTime";

    raw: string;

    year: number;

    month: number;

    day: number;
  };

  export type OriginalSearchPrice = {
    __typename?: "Money";

    currencyInfo?: CurrencyInfo | null;

    amount: number;

    formatted: string;
  };

  export type CurrencyInfo = {
    __typename?: "Currency";

    code: string;

    name: string;

    symbol: string;
  };

  export type ProductInfo = HistoryPropertyDetailInlineFragment;

  export type HistoryPropertyDetailInlineFragment = {
    __typename?: "HistoryPropertyDetail";

    regionId?: string | null;

    summary?: Summary | null;

    propertyId?: string | null;

    gallery?: Gallery | null;
  };

  export type Summary = {
    __typename?: "PropertySummary";

    id: string;

    name: string;
  };

  export type Gallery = {
    __typename?: "PropertyGallery";

    featured?: Featured | null;
  };

  export type Featured = {
    __typename?: "Image";

    url: Url;
  };
}

export namespace DxPropertySearchQuery {
  export type Variables = {
    context: ContextInput;
    hotelIds: string[];
  };

  export type Query = {
    __typename?: "Query";

    propertySearch: PropertySearch;
  };

  export type PropertySearch = {
    __typename?: "PropertySearchResults";

    properties: Properties[];
  };

  export type Properties = {
    __typename?: "Property";

    id: string;

    name: string;

    infositeURL: string;

    price?: Price | null;

    reviews: Reviews;

    gallery?: Gallery[] | null;
  };

  export type Price = {
    __typename?: "PropertyPrice";

    lead?: Lead | null;
  };

  export type Lead = {
    __typename?: "Money";

    formatted: string;

    amount: number;
  };

  export type Reviews = {
    __typename?: "PropertyReviewsSummary";

    score?: number | null;

    total?: number | null;
  };

  export type Gallery = {
    __typename?: "Image";

    url: Url;

    description: string;
  };
}

export namespace MapPropertySearchById {
  export type Variables = {
    context: ContextInput;
    rooms?: RoomInput[] | null;
    dateRange?: PropertyDateRangeInput | null;
    propertyIds?: string[] | null;
    filters?: PropertySearchFiltersInput | null;
  };

  export type Query = {
    __typename?: "Query";

    propertySearch: PropertySearch;
  };

  export type PropertySearch = {
    __typename?: "PropertySearchResults";

    sortAndFilter: SortAndFilter;

    properties: Properties[];
  };

  export type SortAndFilter = {
    __typename?: "SortAndFilter";

    options?: Options | null;
  };

  export type Options = {
    __typename?: "SortAndFilterViewModel";

    sortAndFilter: _SortAndFilter[];
  };

  export type _SortAndFilter = {
    __typename?: "FilterViewModel";

    name: string;

    options: _Options[];
  };

  export type _Options = {
    __typename?: "OptionViewModel";

    label?: string | null;

    value?: string | null;

    range?: Range | null;

    enumValue?: string | null;
  };

  export type Range = {
    __typename?: "FilterOptionRange";

    min?: number | null;

    max?: number | null;
  };

  export type Properties = {
    __typename?: "Property";

    name: string;

    id: string;

    infositeURL: string;

    price?: Price | null;

    reviews: Reviews;

    star?: number | null;

    image?: Image | null;

    mapMarker?: MapMarker | null;
  };

  export type Price = {
    __typename?: "PropertyPrice";

    lead?: Lead | null;
  };

  export type Lead = {
    __typename?: "Money";

    formatted: string;

    amount: number;

    currencyInfo?: CurrencyInfo | null;
  };

  export type CurrencyInfo = {
    __typename?: "Currency";

    symbol: string;

    code: string;

    name: string;
  };

  export type Reviews = {
    __typename?: "PropertyReviewsSummary";

    score?: number | null;

    total?: number | null;

    localizedSubtitle?: string | null;
  };

  export type Image = {
    __typename?: "Image";

    url: Url;
  };

  export type MapMarker = {
    __typename?: "MapMarker";

    latLong: LatLong;
  };

  export type LatLong = {
    __typename?: "Coordinates";

    latitude: number;

    longitude: number;
  };
}

export namespace MapPropertySearchByLatLong {
  export type Variables = {
    context: ContextInput;
    rooms?: RoomInput[] | null;
    dateRange?: PropertyDateRangeInput | null;
    latitude: number;
    longitude: number;
    filters?: PropertySearchFiltersInput | null;
    size?: number | null;
  };

  export type Query = {
    __typename?: "Query";

    propertySearch: PropertySearch;
  };

  export type PropertySearch = {
    __typename?: "PropertySearchResults";

    properties: Properties[];

    summary: Summary;
  };

  export type Properties = {
    __typename?: "Property";

    name: string;

    id: string;

    infositeURL: string;

    price?: Price | null;

    reviews: Reviews;

    star?: number | null;

    image?: Image | null;

    mapMarker?: MapMarker | null;
  };

  export type Price = {
    __typename?: "PropertyPrice";

    lead?: Lead | null;
  };

  export type Lead = {
    __typename?: "Money";

    formatted: string;

    amount: number;
  };

  export type Reviews = {
    __typename?: "PropertyReviewsSummary";

    score?: number | null;

    total?: number | null;

    localizedSubtitle?: string | null;
  };

  export type Image = {
    __typename?: "Image";

    url: Url;
  };

  export type MapMarker = {
    __typename?: "MapMarker";

    latLong: LatLong;
  };

  export type LatLong = {
    __typename?: "Coordinates";

    latitude: number;

    longitude: number;
  };

  export type Summary = {
    __typename?: "PropertyResultsSummary";

    messages?: Messages[] | null;
  };

  export type Messages = {
    __typename?: "MessageResult";

    type?: MessageType | null;

    title?: Title | null;

    subtitle?: Subtitle | null;
  };

  export type Title = {
    __typename?: "MessagingResultTitle";

    text?: string | null;
  };

  export type Subtitle = {
    __typename?: "MessagingResultTitle";

    text?: string | null;
  };
}

export namespace MerchCouponsQuery {
  export type Variables = {
    context: ContextInput;
    couponIds: string[];
  };

  export type Query = {
    __typename?: "Query";

    merchCoupons?: MerchCoupons | null;
  };

  export type MerchCoupons = {
    __typename?: "MerchCoupons";

    coupons: Coupons[];
  };

  export type Coupons = {
    __typename?: "CouponDetail";

    id: string;

    name: string;

    statusMessage: string;

    termsAndConditions: TermsAndConditions;
  };

  export type TermsAndConditions = {
    __typename?: "CouponTermsAndConditions";

    text: string;

    informationUrl: InformationUrl;
  };

  export type InformationUrl = {
    __typename?: "HttpURI";

    value: string;
  };
}

export namespace PropertyFilterSearchQuery {
  export type Variables = {
    context: ContextInput;
    regionId: string;
    filters?: PropertySearchFiltersInput | null;
    sort?: PropertySort | null;
  };

  export type Query = {
    __typename?: "Query";

    propertySearch: PropertySearch;
  };

  export type PropertySearch = {
    __typename?: "PropertySearchResults";

    propertySearchListings: PropertySearchListings[];
  };

  export type PropertySearchListings = MessageResultInlineFragment | PropertyInlineFragment;

  export type MessageResultInlineFragment = {
    __typename?: "MessageResult";

    title?: Title | null;

    subtitle?: Subtitle | null;

    index?: number | null;

    type?: MessageType | null;
  };

  export type Title = {
    __typename?: "MessagingResultTitle";

    icon?: Icon | null;

    text?: string | null;
  };

  export type Icon = {
    __typename?: "Icon";

    description: string;

    id: string;
  };

  export type Subtitle = {
    __typename?: "MessagingResultTitle";

    text?: string | null;
  };

  export type PropertyInlineFragment = {
    __typename?: "Property";

    id: string;

    name: string;

    star?: number | null;

    offerSummary: OfferSummary;

    propertyImage?: PropertyImage | null;

    destinationInfo: DestinationInfo;

    mapMarker?: MapMarker | null;

    reviews: Reviews;

    price?: Price | null;

    propertyDetailsLink?: PropertyDetailsLink | null;

    structureType: StructureType;
  };

  export type OfferSummary = {
    __typename?: "OfferSummary";

    messages?: Messages[] | null;
  };

  export type Messages = {
    __typename?: "OfferSummaryMessage";

    type?: string | null;
  };

  export type PropertyImage = {
    __typename?: "PropertyImage";

    image: Image;
  };

  export type Image = {
    __typename?: "Image";

    url: Url;
  };

  export type DestinationInfo = {
    __typename?: "PropertyDestinationInfo";

    distanceFromMessaging?: string | null;

    distanceFromDestination?: DistanceFromDestination | null;
  };

  export type DistanceFromDestination = {
    __typename?: "Distance";

    unit: DistanceUnit;

    value: number;
  };

  export type MapMarker = {
    __typename?: "MapMarker";

    latLong: LatLong;
  };

  export type LatLong = {
    __typename?: "Coordinates";

    latitude: number;

    longitude: number;
  };

  export type Reviews = {
    __typename?: "PropertyReviewsSummary";

    score?: number | null;

    total?: number | null;
  };

  export type Price = {
    __typename?: "PropertyPrice";

    options?: Options[] | null;
  };

  export type Options = {
    __typename?: "PropertyPriceOption";

    displayPrice?: DisplayPrice | null;
  };

  export type DisplayPrice = {
    __typename?: "Money";

    amount: number;

    formatted: string;

    currencyInfo?: CurrencyInfo | null;
  };

  export type CurrencyInfo = {
    __typename?: "Currency";

    code: string;
  };

  export type PropertyDetailsLink = {
    __typename?: "LodgingLink";

    uri: Uri;
  };

  export type Uri = {
    __typename?: "HttpURI";

    relativePath: string;

    value: string;
  };
}

export namespace PropertyFiltersQuery {
  export type Variables = {
    context: ContextInput;
    regionId: string;
    filters?: PropertySearchFiltersInput | null;
    sort?: PropertySort | null;
  };

  export type Query = {
    __typename?: "Query";

    propertySearch: PropertySearch;
  };

  export type PropertySearch = {
    __typename?: "PropertySearchResults";

    sortAndFilter: SortAndFilter;
  };

  export type SortAndFilter = {
    __typename?: "SortAndFilter";

    options?: Options | null;
  };

  export type Options = {
    __typename?: "SortAndFilterViewModel";

    sortAndFilter: _SortAndFilter[];
  };

  export type _SortAndFilter = {
    __typename?: "FilterViewModel";

    label?: string | null;

    name: string;

    options: _Options[];
  };

  export type _Options = {
    __typename?: "OptionViewModel";

    label?: string | null;

    optionValue?: string | null;

    filterCategory?: string | null;

    description?: string | null;

    selectedLabel?: string | null;

    isSelected: boolean;

    range?: Range | null;
  };

  export type Range = {
    __typename?: "FilterOptionRange";

    max?: number | null;

    min?: number | null;
  };
}

export namespace QueryPropertyHeroImage {
  export type Variables = {
    context: ContextInput;
    propertyId: string;
  };

  export type Query = {
    __typename?: "Query";

    propertyInfo: PropertyInfo;
  };

  export type PropertyInfo = {
    __typename?: "PropertyInfo";

    gallery?: Gallery | null;
  };

  export type Gallery = {
    __typename?: "PropertyGallery";

    featured?: Featured | null;
  };

  export type Featured = {
    __typename?: "Image";

    description: string;

    url: Url;
  };
}

export namespace QueryPropertyReviewsHeadline {
  export type Variables = {
    context: ContextInput;
    propertyId: string;
  };

  export type Query = {
    __typename?: "Query";

    propertyInfo: PropertyInfo;
  };

  export type PropertyInfo = {
    __typename?: "PropertyInfo";

    infositeUrl?: Url | null;

    summary?: Summary | null;
  };

  export type Summary = {
    __typename?: "PropertySummary";

    id: string;

    name: string;

    overview?: Overview | null;

    location?: Location | null;
  };

  export type Overview = {
    __typename?: "PropertyOverview";

    starRating?: number | null;
  };

  export type Location = {
    __typename?: "PropertyLocation";

    address?: Address | null;
  };

  export type Address = {
    __typename?: "PropertyAddress";

    city?: string | null;

    countryCode?: string | null;

    firstAddressLine?: string | null;

    secondAddressLine?: string | null;

    postalCode?: string | null;

    province?: string | null;
  };
}

export namespace PropertySearchQuery {
  export type Variables = {
    context: ContextInput;
    hotelIds: string[];
  };

  export type Query = {
    __typename?: "Query";

    propertySearch: PropertySearch;
  };

  export type PropertySearch = {
    __typename?: "PropertySearchResults";

    properties: Properties[];
  };

  export type Properties = {
    __typename?: "Property";

    id: string;

    name: string;

    gallery?: Gallery[] | null;
  };

  export type Gallery = {
    __typename?: "Image";

    url: Url;

    description: string;
  };
}
